import { alpha } from "@mui/material"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"

const mixins = {
  content: {
    width: 1410,
    height: 1000,
  },
  aside: {
    width: 390,
  },
  hKioskHeader: {
    height: 110, // kiosk header
  },
  hKioskFooter: {
    height: 0, // kiosk footer
  },
  kioskNavigation: {
    height: 240,
    width: "32dvw",
  },
  collapsedContent: {
    width: 1280,
  },
  expandedContent: {
    width: 520,
  },
  bottomNavigation: {
    height: 80,
  },
  mobileHeader: {
    height: 70,
  },
  mobileDirectionSearch: {
    width: 380,
  },
}

export const themeOptionFactory = (theme) => ({
  mixins,
  assets: {
    /**
     * The icon configuration format for pages with no data.
     * Example:
     * promotions: {
     *   "icon_comp": "_COMPONENT_NAME_", // optional
     *   "icon_path": "_SVG_PATH_", // optional
     *   "icon_img": "_IMG_SRC_", // optional
     * }
     */
    empty: {
      promotions: {},
      events: {},
      dining: {},
      newShops: {},
      directory: {},
      touristPrivilege: {},
    },
    /**
     * The platform's application logo.
     */
    platforms: {
      hungryhub: {
        url: "https://s3.venue.in.th/A_Idro_l_Tu_L_kv_SBUZW_Yuq_ISO_Bx_Ve_W_Ud_O2_Pnbedds_R_Kghe_S_Cz_Q_s900_c_k_c0x00ffffff_no_rj_c0581c6d35.jpeg",
      },
      queq: {
        url: "https://s3.venue.in.th/y_L_bck_Ze_HH_0oj_DL_Yute_DVQ_Tqz_CY_9um_R2e_N4j0lg0xt0qsp_Z6_IGA_Bxjsd_U_Ng_YGB_94mw_dfc33a12b5.png",
      },
      "lineman-wongnai": {
        url: "https://s3.venue.in.th/xq_HA_S_Yn_WC_3_HYA_Qi1_J_Zg_MP_Fax_YX_2_WQ_Ly_twv44_YWC_9_Q_N_Xe_BUM_Avj_PZZ_1a_N8_U7k_Nj8w_1e5e370eff.png",
      },
      eatable: {
        url: "https://s3.venue.in.th/l_K_Ovo4pjjn_NBS_Yi_Hc5a_Ak_N_2n_Bl_Zd_T_To_J_Ea6_Gq_Xes_OF_g_Ae_P1_Rjrr_BFG_6mng_Iu_P_Akw_5fdd964546.png",
      },
      openrice: {
        url: "https://s3.venue.in.th/e_HPT_6_Rvg_P_Cvp_Tv3m_Iz_Ve_LSH_Nc_R2_Ld_L_Prisuc_W_Aw_HFQJ_Vi_Q_One5wy19b_NSL_2eqbpkjc_Y_81c808f384.png",
      },
      gowabi: {
        url: "https://s3.venue.in.th/images_63738e7e38.jpeg",
      },
      klook: {
        url: "https://s3.venue.in.th/oi_Wp_ZPNU_77_Yig_Mo_C1ia_Xds_X_Do_U34_PWP_63_M5c0e_ZCR_l6_O3_WT_Pn_D48_Cubgmto_Q_Eah_P_w_de9ea54f47.png",
      },
      eatigo: {
        url: "https://s3.venue.in.th/uz2_M4x_CF_Myr_Yk_Y_Elyw8_AVM_Rey_In_Q_Wxa0f_CMK_Adza_Ndm_ZB_9_IE_Es_K_Qzrj_HIA_93pg_SU_ee5069fa31.png",
      },
      booking: {
        url: "https://s3.venue.in.th/3_Kf2_Yyo_yg14_Js9_QSZNGT_Az_Vt_Zdl_Eaxce_PVCD_Hza_Ph_AH_6u_E_Vd_T7l_Ttz19_Yrx1po_Vbpal_s256_rw_ba5c09394c.webp",
      },
      agoda: {
        url: "https://s3.venue.in.th/Q_Fl5_Rn_Jn_Ca_Apuw_SY_5_Gky_Pk1_Yq_F_Rdeq_64_E_Hae_Ne_Y_Id3_Hw_Y9_Uqjf5_Jk_R_Ve_AT_Zxuu_Kez5o_08a5bc0a66.png",
      },
      tripadvisor: {
        url: "https://s3.venue.in.th/Eo_Rc_Rtru5_F_Lis_Rd0k_CJ_5_Ee_Tb_DQS_8o_Zt_LYI_Tsg_58_Gv52ryuj_Jtq_Yw_QU_Yf_D_Dw_Y3_Y9c2_U_a93799697d.png",
      },
      resy: {
        url: "https://s3.venue.in.th/Nli_O_Gci_JF_8_v8m_T_Pj_Dn_FI_4_L_qrtmqz_G0_C_Tx5u0_LH_Ug_FMNO_66_QB_1q_Hw_Kf_Wfip_DVHHY_048b1a4c6b.png",
      },
      opentable: {
        url: "https://s3.venue.in.th/6_EU_Alv_RT_1_Umzip_X_Vyvtlt_Q0n_Lh_OLB_wkghb_HEI_Bdsczl4_Ln_Eh_W6o7e_HS_Zhxa_Ay0_Wc_eade25cd18.png",
      },
      tablecheck: {
        url: "https://s3.venue.in.th/Table_Check_jpg_e4abf4794b.aspx",
      },
      facebook: {
        url: "https://s3.venue.in.th/KCMT_Yui_Tr_Kom4_Vyf0_G4foet_V_Owh_K_Wz_Nb_H_Wum_V73_I_Xex_A_Iy5_T_Tg_Zip_L52_W_Tt8_ICL_o_Io_01a299e85c.png",
      },
      instagram: {
        url: "https://s3.venue.in.th/VRM_Wk_E5p3_Ck_Wh_Js6nv_9_Zs_L_As1_Q_Og5ob1_3qg_rckw_YW_7yp1f_Mr_Y_Zqn_E_Fpk0_Io_VP_4_LM_12f0569ace.png",
      },
      line: {
        url: "https://s3.venue.in.th/74i_M_Ob_G1vs_R3_Kfm82_Rj_ER_Fhf99_QFMNIY_211o_Mv_N636_g_U_Lghb_RB_Mjp_VF_Tj_OK_36ox_Cbs_50869ab4b3.png",
      },
      "twitter-x": {
        url: "https://s3.venue.in.th/A_Rnrh0_J7i_Km_A_Bsk_Tonq_FAANRLGTG_Ug_nu_E4_PEM_Yw_Jav_L3n_Pt5u_Ws_U2_WO_D_Sg_V_m_OOM_4485813680.png",
      },
      tiktok: {
        url: "https://s3.venue.in.th/Bm_U_Vi_DVOKN_Je0_GY_Je22hsr7ju_Fnd_R_Vbvr1f_Gm_HG_Xq_Hf_Jj_NA_Xjd26bfu_GR_Qp_Vrp_J6_Yb_A_35a4e2b103.png",
      },
      youtube: {
        url: "https://s3.venue.in.th/6am0i3wal_Yw_N_Lc08_QO_Oh_R_Jtt_QENN_Gkhl_Kaj_XSE_Rf3_Jn_PVR_Qcz_Iyxw2w3_Dxe_MRTO_Sds_Y_f4eff792ef.png",
      },
      threads: {
        url: "https://s3.venue.in.th/G6j_K9_S77_RN_0laf9_6nh_Do3_A_Vxb_RP_9_Sg_Mmt8_Zm_Qj_KQ_2hibn9xh_OY_W5_Y_Fn_7st_JD_1_CA_ee64a782ec.png",
      },
      chope: {
        url: "https://s3.venue.in.th/chope_fc476e0327.png",
      },
      jpneasy: {
        url: "https://s3.venue.in.th/jpneasy_fd9e457b0f.png",
      },
    },
    storeDownload: {
      ios: {
        url: "https://s3.venue.in.th/ios_store_download_button_f012d18f26.png",
      },
      android: {
        url: "https://s3.venue.in.th/store_download_button_70d404d1a9.png",
      },
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        /* Override style to apply solid color filter for CustomImageIcon component. */
        "#searchListItem_avatar_filter .solid-color-filter": {
          // display: "none" // Disable filter
          // floodColor: "currentColor" // Set solid color (default: currentColor).
        },
        "#diningCard_cover_filter .solid-color-filter": {},
        "#diningCard_avatar_filter .solid-color-filter": {},
        "#directoryCard_avatar_filter .solid-color-filter": {},
        "#placeDetail_avatar_filter .solid-color-filter": {},
        "#shopPromotion_avatar_filter .solid-color-filter": {},
        "#step_avatar_filter .solid-color-filter": {},
        "#directionOverview_avatar_filter .solid-color-filter": {},
        "#newShop_cover_filter .solid-color-filter": {},
        "#newShop_avatar_filter .solid-color-filter": {},
        "#stepOverview_avatar_filter .solid-color-filter": {},
        /* End Override style to apply solid color filter for CustomImageIcon component. */

        // Used with usePageSideBar layout to control content and sidebar structure within the app.
        "&.is-open-sidebar": {
          "& #map": {
            marginLeft: `${
              mixins.collapsedContent.width - mixins.content.width
            }px`,
          },
          "& .AppLayout-indoorMapWrapper": {
            width: mixins.collapsedContent.width,
          },
          "& .ContentWithAside-contentWrapper": {
            width: mixins.collapsedContent.width,
          },
          "& .ContentWithAside-asideWrapper": {
            width: mixins.expandedContent.width,
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        outlinedSizeMedium: {
          fontSize: "1.25rem",
          fontWeight: 400,
        },
        startIcon: {
          marginRight: theme.spacing(0.75),
        },
        endIcon: {
          marginLeft: theme.spacing(0.75),
        },
        sizeMedium: {
          paddingTop: theme.spacing(2),
        },
      },
    },
    SplitrPlayer: {
      defaultProps: {
        iframeOptions: {},
      },
      styleOverrides: {
        iframe: {
          top: theme.spacing(5),
          left: theme.spacing(5),
          bottom: theme.spacing(5),
          width: "1400px",
          height: "1000px",
          pointerEvents: "none",
          position: "absolute",
          zIndex: 1,
          borderRadius: "32px",
          "&.hidden": {
            display: "none",
          },
        },
      },
    },
    AppLayout: {
      styleOverrides: {
        headerWrapper: { display: "none" },
        indoorMapWrapper: {
          position: "absolute",
          margin: theme.spacing(5),
          top: 0,
          width: mixins.content.width,
          maxWidth: mixins.content.width,
          overflow: "hidden",
          borderRadius: "32px",
          transition: `all ${theme.transitions.duration.short}ms ${theme.transitions.easing.easeInOut} ${theme.transitions.duration.shortest}ms`,
        },
        contentWrapper: {
          position: "relative",
        },
      },
    },
    AppMapLayout: {
      styleOverrides: {},
    },
    AppPageLayout: {
      styleOverrides: {
        root: {
          height: "100%",
          overflow: "hidden",
        },
      },
    },
    AppContentWithAside: {
      styleOverrides: {
        root: {
          height: "100dvh",
          display: "flex",
          width: "100dvw",
          padding: theme.spacing(5),
          gap: theme.spacing(5),
        },
        contentWrapper: {
          width: mixins.content.width,
          position: "relative",
          flexShrink: 0,
          transition: `width ${theme.transitions.duration.short}ms ${theme.transitions.easing.easeInOut} ${theme.transitions.duration.shortest}ms`,
        },
        asideWrapper: {
          position: "relative",
          width: mixins.aside.width,
          flexShrink: 0,
          transition: `width ${theme.transitions.duration.short}ms ${theme.transitions.easing.easeInOut} ${theme.transitions.duration.shortest}ms`,
        },
      },
    },
    AppMapPageLayout: {
      styleOverrides: {
        root: {
          position: "absolute",
          top: 0,
          right: 0,
          left: 0,
          bottom: 0,
          pointerEvents: "none",

          "& .ContentWithAside-contentWrapper": {
            pointerEvents: "inherit",
            "& > *": {
              pointerEvents: "all",
            },
          },
          "& .ContentWithAside-asideWrapper": { pointerEvents: "all" },
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        root: {
          width: 50,
          height: 30,
          padding: 0,
          margin: theme.spacing(1),
          display: "flex",
          alignItems: "center",
          "& .MuiSwitch-thumb": {
            color: "white",
            boxShadow: "none",
            width: 20,
            height: 20,
            borderRadius: 9999,
            transition: theme.transitions.create(["width"], {
              duration: 200,
            }),
          },
          "& .MuiSwitch-track": {
            borderRadius: 9999,
            opacity: 1,
            backgroundColor: theme.palette.grey[100],
            boxSizing: "border-box",
          },
          "&:active": {
            "& .MuiSwitch-thumb": {
              width: 20,
            },
            "& .MuiSwitch-switchBase.Mui-checked": {
              transform: "translateX(9px)",
            },
          },
          "& .MuiSwitch-switchBase": {
            padding: 5,
            "&.Mui-checked": {
              transform: "translateX(20px)",
              "& + .MuiSwitch-track": {
                opacity: 1,
                backgroundColor: "#3DB357",
              },
            },
            "&.Mui-disabled": {
              "& .MuiSwitch-thumb": {
                backgroundColor: theme.palette.grey[100],
              },
              "& + .MuiSwitch-track": {
                opacity: 1,
                backgroundColor: theme.palette.grey[50],
              },
              "&.Mui-checked": {
                "& .MuiSwitch-thumb": {
                  backgroundColor: theme.palette.grey[300],
                },
                "& + .MuiSwitch-track": {
                  backgroundColor: theme.palette.grey[100],
                },
              },
            },
          },
        },
        sizeSmall: {
          width: 30,
          height: 18,
          "&:active": {
            "& .MuiSwitch-thumb": {
              width: 16,
            },
            "& .MuiSwitch-switchBase.Mui-checked": {
              transform: "translateX(9px)",
            },
          },
          "& .MuiSwitch-switchBase": {
            padding: 2,
            "&.Mui-checked": {
              transform: "translateX(12px)",
            },
          },
          "& .MuiSwitch-thumb": {
            width: 14,
            height: 14,
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          borderColor: theme.palette.grey[500],
          "&.Mui-disabled": {
            backgroundColor: "#ECECEC",
          },
        },
      },
    },
    MuiSelect: {
      defaultProps: {
        IconComponent: ExpandMoreIcon,
      },
      styleOverrides: {
        select: {
          padding: theme.spacing(1.5, 4, 1.5, 2),
          borderRadius: "8px",
          fontSize: 12,
        },
        icon: {
          color: theme.palette.primary.main,
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: "0.75rem",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        notchedOutline: {
          fontSize: "0.75rem",
        },
      },
    },
    AppSidebar: {
      styleOverrides: {
        wrapper: {
          display: "flex",
          flexDirection: "column",
          height: "100%",
        },
        header: {},
        body: {
          flex: 1,
        },
        footer: { marginBottom: theme.spacing(4) },
        playerButton: {
          fontSize: "1rem",
          flex: 1,
          fontWeight: 700,
          padding: theme.spacing(1.5, 3),
          "& .MuiSvgIcon-root": {
            width: "24px",
            height: "24px",
          },
        },
      },
    },
    AppDining: {
      styleOverrides: {
        filterContainer: {
          paddingLeft: 0,
          paddingBottom: 3,
        },
        filterButton: {
          whiteSpace: "nowrap",
          gap: theme.spacing(2),
          "& .MuiSvgIcon-root": {
            marginRight: theme.spacing(1),
          },
          ":first-of-type": {
            marginLeft: theme.spacing(3),
          },
        },
        diningImageCard: {
          display: "block",
          width: "235px",
          height: "235px",
          "& .MuiCardActionArea-root, & .MuiCardMedia-root": {
            height: "100%",
            width: "100%",
          },
          "& .MuiCardHeader-root": {
            padding: theme.spacing(2),
          },
          "& .MuiCardHeader-root .MuiCardHeader-title": {
            lineHeight: 1.3,
          },
          "& .MuiCardHeader-content": {
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignSelf: "stretch",
          },
          "& .MuiCardHeader-title": {
            overflow: "hidden",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            marginBottom: theme.spacing(0.1875),
            fontWeight: 700,
          },
          "& .MuiCardHeader-subheader": {
            fontWeight: 400,
            "& .sub-category-text": {
              overflow: "hidden",
              fontSize: "0.75rem",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              maxWidth: "90%",
              display: "none",
            },
            "& .booth-name-text": {
              overflow: "hidden",
              fontSize: "0.75rem",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              maxWidth: "90%",
              display: "none",
            },
          },
          "&.no-image": {
            "& .MuiCardActionArea-root:after": {},
          },
          "& .MuiCardHeader-root .MuiCardHeader-avatar": {
            marginRight: theme.spacing(2),
          },
          "& .MuiCardHeader-avatar .MuiAvatar-root": {
            width: "64px",
            height: "64px",
            "& .MuiSvgIcon-root": {
              width: "32px",
              height: "32px",
            },
          },
        },
        diningAvatarFallBack: {},
        diningFallbackImageIconWrapper: {
          display: "flex",
          justifyContent: "center",
          alignItems: "start",
          color: theme.palette.common.white,
          height: "100%",
          width: "100%",
          background: theme.palette.grey[500],
          paddingTop: "30%",
        },
        diningFallbackImageIcon: {
          height: "64px",
          width: "64px",
          zIndex: 1,
        },
        filterSection: {
          position: "absolute",
          left: "50%",
          zIndex: 2,
          transform: "translateX(-50%)",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          bottom: 0,
          width: "100%",
          maxWidth: "calc(100% - 64px)", // 64px = 32px (padding content side) * 2
          marginBottom: theme.spacing(3),
          "&:after": {
            content: "''",
            display: "inline-block",
            width: "20px",
            background:
              "linear-gradient(90deg, rgba(255, 255, 255, 0.00) 10%, #fff 90%)",
            zIndex: 1,
            position: "absolute",
            right: "-4px",
            top: 0,
            bottom: 0,
          },
          "&:before": {
            content: "''",
            display: "inline-block",
            width: "20px",
            background:
              "linear-gradient(90deg, #fff 10%, rgba(255, 255, 255, 0.00) 90%)",
            zIndex: 1,
            position: "absolute",
            left: "-4px",
            top: 0,
            bottom: 0,
          },
          "& .MuiToggleButton-root": {
            alignItems: "center",
            "& .MuiSvgIcon-root": {},
          },
          "& .MuiToggleButtonGroup-root": {
            gap: theme.spacing(2),
            paddingLeft: theme.spacing(2),
            margin: "0 auto",
          },
          "& .MuiToggleButton-root:first-of-type": {
            marginLeft: 0,
          },
          "& .MuiToggleButton-root:last-of-type": {
            marginRight: 0,
          },
        },
        scrollPane: {
          padding: 0,
        },
        venueSelector: {
          position: "fixed",
          bottom: "175px",
          right: "690px",
          zIndex: 2,
        },
        contentWrapper: {
          height: "100%",
        },
        emptyDataWrapper: {
          position: "absolute",
          left: "50%",
          top: "50%",
          transform: "translate(-50%, -50%)",
          width: "370px",
        },
        gridContainer: {
          position: "relative",
          display: "grid",
          gridAutoFlow: "dense",
          gridAutoRows: "max-content",
          gridTemplateColumns: "repeat(auto-fill, minmax(235px, 1fr))",
          gap: theme.spacing(3),
          overflowY: "auto",
          height: "calc(100% - 80px)",
          //hide scrollbar
          "::-webkit-scrollbar": {
            display: "none",
          },
          MsOverflowStyle: "none",
          scrollbarWidth: "none",
          "&.emptyList": {},
        },
        gridItem: {
          height: "230px",
        },
        pageCard: {
          "&:after": {
            content: "''",
            pointerEvents: "none",
            display: "inline-block",
            position: "absolute",
            zIndex: 1,
            left: 0,
            right: 0,
            bottom: 80,
            minHeight: "180px",
            background:
              "linear-gradient(0deg, #FFF 2.8%, rgba(255, 255, 255, 0.00) 50%)",
          },
        },
        subCategoryFilterBar: {
          "& .MuiToggleButton-root": {
            height: "48px",
          },
        },
      },
    },
    AppCategoryFilterButton: {
      styleOverrides: {
        root: {
          padding: 0,
          width: 85,
          flexDirection: "column",
          justifyContent: "start",
          gap: theme.spacing(1),
          border: "none",
          color: theme.palette.text.primary,
          "&.Mui-selected": {
            "& .MuiSvgIcon-root": {
              color: theme.palette.primary.contrastText,
            },
            "& .MuiTypography-root": {
              color: theme.palette.primary.main,
            },
            "& .MuiBox-root": {
              backgroundColor: theme.palette.primary.main,
            },
          },
          "&.Mui-selected, &.Mui-selected:hover, &.MuiToggleButton-root:hover":
            {
              backgroundColor: "unset",
            },
        },
        label: {
          fontSize: "0.75rem",
          textAlign: "center",
          lineHeight: 1.1,
          color: theme.palette.text.primary,
          fontWeight: 600,
          letterSpacing: "0.24px",
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 2,
          overflow: "hidden",
          whiteSpace: "normal",
          wordBreak: "break-word",
          width: 100,
        },
        icon: {
          width: 80,
          height: 80,
          padding: theme.spacing(1.25),
          borderRadius: "8px",
          boxShadow: "0px 4px 20px 0px rgba(0, 0, 0, 0.10)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderColor: "none",
          "& .MuiSvgIcon-root": {
            width: 48,
            height: 48,
          },
        },
      },
    },
    AppCategoryFilterChip: {
      styleOverrides: {
        root: {
          padding: theme.spacing(1, 2),
          borderRadius: "8px",
          boxShadow: "none",
          background: theme.palette.common.white,
          border: `1px solid ${theme.palette.grey[200]} `,
          whiteSpace: "nowrap",
          height: "40px",
          color: theme.palette.grey[600],
          fontWeight: 400,
          "&.MuiToggleButtonGroup-grouped:not(:last-of-type)": {
            margin: 0,
          },
          "&.MuiToggleButtonGroup-grouped:not(:first-of-type)": {
            border: `1px solid ${theme.palette.grey[200]} `,
            margin: 0,
          },
          "&.Mui-selected": {
            background: theme.palette.primary.main,
            "& svg": {
              fill: theme.palette.primary.contrastText,
            },
          },
          ":hover": {
            background: theme.palette.common.white,
          },
        },
        label: {
          fontSize: "0.875rem",
          padding: theme.spacing(0, 1.5),
          letterSpacing: "0.00938em",
        },
        icon: {
          display: "flex",
          alignItems: "center",
          fill: theme.palette.text.primary,
          "& svg": {
            width: 16,
            height: 16,
            fill: theme.palette.grey[600],
            marginLeft: theme.spacing(0.5),
            marginRight: theme.spacing(-0.75),
          },
        },
      },
    },
    AppCategoryFilterBar: {
      styleOverrides: {
        root: {},
        filterButton: {},
      },
    },
    WelcomePanel: {
      defaultProps: {
        showNavigation: false,
        showQuickSearch: true,
      },
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.grey[50],
        },
        panelContainer: {
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-end",
        },
        line: {
          position: "absolute",
          left: 0,
          right: 0,
          bottom: 0,
          width: "100%",
          height: "3px",
          border: "none",
          background: `linear - gradient(90deg, ${theme.palette.primary.main} 0 %, ${theme.palette.common.white} 100 %)`,
        },
        content: {
          position: "relative",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: theme.spacing(6.75, 3, 2),
          [theme.breakpoints.up("sm")]: {
            width: 460,
          },
        },
        logoContainer: {
          display: "flex",
          justifyContent: "flex-start",
          width: "100%",
          marginBottom: theme.spacing(3),
          "& img": {
            maxWidth: 130,
          },
        },
        searchBarContainer: {
          marginBottom: theme.spacing(2),
          width: "100%",
        },
        navItem: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start",
          color: "white",
          flexBasis: 0,
          fontSize: theme.typography.subTitle.fontSize,
          fontWeight: theme.typography.fontWeightRegular,
          lineHeight: "19px",
          flexGrow: "1",
          textAlign: "center",
          "& .MuiButton-startIcon": {
            margin: theme.spacing(0, 0, 1.5),
            width: 20,
            height: 20,
          },
        },
        horizontalMenuContainer: {
          padding: 0,
        },
      },
    },
    AppHeader: {
      styleOverrides: {
        root: {
          position: "sticky",
          left: 0,
          top: 0,
          right: 0,
          justifyContent: "center",
          minHeight: mixins.hKioskHeader.height,
          backgroundColor: theme.palette.grey[50],
          boxShadow: "none",
          width: "100%",
          color: theme.palette.text.primary,
          fontWeight: 600,
        },
        toolbar: {
          padding: theme.spacing(0, 9),
          maxWidth: "none",
          minHeight: mixins.mobileHeader.height,
          justifyContent: "space-between",
          width: "100%",
          [theme.breakpoints.up("md")]: {
            padding: theme.spacing(0, 8),
            margin: `0 auto`,
            maxWidth: "none",
          },
        },
        logoContainer: {
          display: "inline-block",
        },
        titleContainer: {
          display: "none",
        },
        clockContainer: {
          display: "inline-block",
        },
        backButtonContainer: {
          display: "none",
        },
        line: {
          display: "none",
          position: "absolute",
          left: 0,
          right: 0,
          bottom: 0,
          width: "100%",
          height: "3px",
          border: "none",
          background: `linear - gradient(90deg, ${theme.palette.primary.main} 0 %, ${theme.palette.common.white} 100 %)`,
        },
      },
    },
    AppClock: {
      defaultProps: {
        dateFormat: "LLL",
        timeFormat: "hh:mm",
        timeUnitFormat: "A",
      },
      styleOverrides: {
        root: {
          color: theme.palette.text.primary,
          textTransform: "uppercase",
          gap: theme.spacing(8),
          lineHeight: 1.2,
          "& .MuiDivider-root": {
            display: "none",
          },
        },
        timeWrapper: {
          fontWeight: 400,
          textAlign: "left",
          fontSize: "24px",
        },
        dateContainer: {
          gap: theme.spacing(1.5),
        },
        divider: {},
        timeContainer: {
          gap: theme.spacing(1.5),
        },
        dateText: {
          fontWeight: 400,
          fontSize: "24px",
        },
        timeLabel: {
          display: "none",
        },
        timeText: {},
        timeUnitText: {
          fontWeight: 400,
          fontSize: "24px",
          marginBottom: theme.spacing(2),
        },
        icon: {
          "& .MuiSvgIcon-root": {
            width: 45,
            height: 45,
          },
        },
      },
    },
    // Navigation
    MuiBottomNavigation: {
      styleOverrides: {
        root: {
          width: "100%",
          overflow: "hidden",
        },
      },
    },

    MuiBottomNavigationAction: {
      styleOverrides: {
        root: {
          maxWidth: "unset",
          padding: theme.spacing(1, 5),
          "& .MuiSvgIcon-root": {
            marginBottom: 8,
            width: 20,
            height: 20,
          },
          "&.Mui-selected": {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main,
            "&:after": {
              display: "none",
            },
          },
          "&.Mui-disabled": {
            color: theme.palette.action.disabled,
            "& .MuiSvgIcon-root": {
              color: theme.palette.action.disabled,
            },
          },
        },
        label: {
          textAlign: "left",
          fontSize: "1rem",
          textTransform: "uppercase",
        },
      },
    },
    VuiNavigationControl: {
      styleOverrides: {
        wrapper: {
          "> *": {
            flex: 1,
          },
        },
        navigationAction: {},
        languageButton: {
          flexDirection: "column",
          color: "text.secondary",
          background: "none",
          "&:hover": { background: "none" },
        },
      },
    },
    AppKioskNavigation: {
      styleOverrides: {
        root: {
          height: "100%",
          maxWidth: "100%",
        },
        menuButton: {
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-start",
          gap: theme.spacing(2),
          alignItems: "center",
          color: theme.palette.text.secondary,
          fontWeight: 400,
          "& .MuiSvgIcon-root": {
            width: 48,
            height: 48,
            margin: 0,
          },
          "& .MuiBottomNavigationAction-label": {
            fontSize: "1.5rem",
          },
          padding: theme.spacing(0, 5),
          "&.Mui-selected": {
            color: theme.palette.primary.contrastText,
            "& .MuiBottomNavigationAction-label": {
              fontSize: "1.5rem",
            },
          },
        },
        navigationWrapper: {
          height: "100%",
        },
        navigationContainer: {
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(290px, 1fr))",
          gap: 0,
          height: "100%",
          alignItems: "stretch",
        },
        toolbarContainer: {
          display: "none",
        },
        searchBarContainer: {
          display: "none",
        },
        actionContainer: {
          display: "none",
        },
        actionButton: {
          minWidth: 128,
          backgroundColor: theme.palette.common.white,
          color: theme.palette.text.primary,
          "&:hover": {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
          },
          "& .MuiSvgIcon-root": {
            marginRight: 0,
            width: 32,
            height: 32,
          },
        },
      },
    },
    AppBanner: {
      styleOverrides: {
        root: {
          height: "62px",
          margin: theme.spacing(5, 5, 3),
          backgroundSize: "172px",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        },
      },
    },
    AppFooter: {
      styleOverrides: {
        root: {
          height: mixins.hKioskFooter.height,
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 1200,
        },
      },
    },
    AppTopBar: {
      styleOverrides: {
        root: {
          display: "none",
        },
        ordinalSelector: {
          position: "static",
          "& .OrdinalSelector-root": {},
          "& .OrdinalSelector-list": {
            borderRadius: 9999,
            width: "48px",
            height: "48px",
            padding: theme.spacing(0.4),
          },
          "& .OrdinalSelector-label": {},
          "& .OrdinalSelector-button": {
            height: "100%",
          },
        },
        backButton: {
          color: theme.palette.primary.main,
        },
      },
    },
    DirectionSearchInput: {
      styleOverrides: {
        directionSearchWrapper: {
          boxShadow: theme.shadows[1],
          background: theme.palette.common.white,
          padding: theme.spacing(3, 2),
          borderRadius: "10px",
          display: "flex",
        },
        backIconWrapper: {
          display: "flex",
          alignItems: "start",
          justifyContent: "center",
          marginRight: theme.spacing(1),
        },
        directionWrapper: {
          flexGrow: 1,
          display: "flex",
        },
        switchIconWrapper: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginLeft: theme.spacing(1),
        },
        directionInputWrapper: {
          display: "flex",
          flexDirection: "column",
          flexGrow: 1,
        },
        directionIconWrapper: {
          display: "flex",
          justifyContent: "space-evenly",
          flexDirection: "column",
          marginRight: theme.spacing(1.5),
        },
        directionInput: {
          fontSize: "0.875rem",
          fontWeight: 500,
          flexGrow: 1,
          padding: theme.spacing(0, 0.5),
          "& .MuiInputBase-input": {
            padding: 0,
          },
        },
        iconButton: {
          color: theme.palette.text.primary,
          fontSize: "24px",
          margin: "-5px",
        },
        divider: {
          margin: theme.spacing(1, 0),
          borderBottomWidth: "1px",
        },
        clearIconButton: {
          color: theme.palette.text.primary,
          fontSize: "24px",
          margin: "-5px",
          "& .MuiSvgIcon-root": {
            height: "8px",
            width: "8px",
          },
        },
      },
    },
    AppDirectionSearch: {
      styleOverrides: {
        headerWrapper: {
          display: "none",
        },
        paper: {
          borderRadius: "10px",
          padding: theme.spacing(0.75, 1.25),
          display: "flex",
          alignItems: "center",
        },
        formControlLabel: {
          margin: 0,
          "& .MuiFormControlLabel-label": {
            fontWeight: 500,
            marginLeft: theme.spacing(2),
          },
        },
      },
    },
    AppMap: {
      styleOverrides: {
        toolbarContainer: {
          position: "fixed",
          bottom: 64,
          display: "flex",
          flexDirection: "column",
        },
        quickLinkContainer: {
          overflow: "hidden",
          padding: theme.spacing(0, 4),
          display: "flex",
          order: 0,
          maxWidth: "1410px",
        },
        ordinalSelectMenu: {
          position: "absolute",
          bottom: 200,
          right: 40,
        },
        ordinalSelectSplide: {
          display: "none",
        },
        indoorMapContainer: {
          height: "100%",
          borderRadius: `16px`,
          overflow: "hidden",
          "& #map": {
            marginLeft: 0,
            width: mixins.content.width,
            height: mixins.content.height,
          },
        },
        venueSelector: {
          display: "none",
        },
        locationButtonContainer: {
          display: "flex",
          position: "absolute",
          right: 40,
          bottom: 96,
        },
      },
    },
    AppNavigationStep: {
      styleOverrides: {
        root: {
          padding: theme.spacing(4, 4, 0),
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        },
        wrapper: {},
        container: {},
        kioskBackButton: {},
        title: {},
        highlightedText: {},
        locationAvatar: {
          width: 80,
          height: 80,
          margin: 0,
          backgroundColor: theme.palette.primary.main,
        },
        originAvatar: {
          backgroundColor: "transparent",
        },
        locationText: {
          fontWeight: 700,
          color: theme.palette.text.primary,
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 1,
          overflow: "hidden",
        },
        originText: {
          display: "none",
        },
        originIcon: {
          width: "80px",
          height: "80px",
        },
        destinationIcon: {
          width: "40px",
          height: "40px",
        },
        actionContainer: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          marginTop: theme.spacing(4),
          gap: theme.spacing(3),
          width: "100%",
        },
        stepContainer: {
          height: "auto",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "flex-start",
          gap: theme.spacing(1),
          marginTop: theme.spacing(0.5),
          marginRight: "auto",
        },
        stepItem: {
          height: "auto",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: theme.spacing(1.25),
        },
        overviewWrapper: {},
        navButtonWrapper: {},
        iconNavButton: {},
        exitButtonWrapper: {},
        exitButton: {},
        ordinalSelector: {
          position: "fixed",
          bottom: "92px",
          right: "534px",
          marginRight: theme.spacing(1.5),
          "& .OrdinalSelector-root": {
            borderRadius: 9999,
            height: "auto",
            padding: theme.spacing(2, 1),
            width: "72px",
            boxShadow: "none",
            border: `1px solid #ececec`,
            backgroundColor: alpha(theme.palette.background.paper, 0.8),
          },
          "& .OrdinalSelector-list": {
            width: "56px",
            height: "56px",
            padding: 0,
            backgroundColor: theme.palette.background.paper,
            marginTop: theme.spacing(1),
          },
          "& .OrdinalSelector-label": {
            textAlign: "center",
            display: "block",
            fontSize: "1rem",
          },
          "& .OrdinalSelector-button": {
            height: "100%",
            fontWeight: 700,
          },
        },
        playerActionContainer: {
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          gap: theme.spacing(2),
          width: "100%",
          "& .prevButton": {},
          "& .playButton": {
            display: "none",
          },
          "& .nextButton": {},
        },
        primaryButton: { flex: 1 },
        secondaryButton: { flex: 1 },
        stepProgressBarContainer: {
          position: "relative",
          "&:after": {
            content: "''",
            display: "inline-block",
            height: "20px",
            background:
              "linear-gradient(180deg, rgba(255, 255, 255, 0.00) 10%, #fff 90%)",
            zIndex: 2,
            position: "absolute",
            bottom: theme.spacing(-0.25),
            left: 0,
            right: 0,
          },
          "&:before": {
            content: "''",
            display: "inline-block",
            height: "20px",
            background:
              "linear-gradient(0, rgba(255, 255, 255, 0.00) 10%, #fff 90%)",
            zIndex: 2,
            position: "absolute",
            top: theme.spacing(-0.25),
            left: 0,
            right: 0,
          },
        },
        stepProgressBar: {
          height: "400px",
          padding: theme.spacing(0),
          "& > .MuiStepper-root": {
            padding: theme.spacing(0, 0, 0, 2.875),
          },
        },
        sidebarContent: {},
      },
    },
    AppFeatureDetail: {
      styleOverrides: {
        root: {
          position: "relative",
          overflow: "initial",
          boxShadow: "none",
        },
        section: {
          margin: theme.spacing(3, 0),
          "&:first-of-type": {
            marginTop: 0,
          },
          color: theme.palette.text.secondary,
        },
        galleryImage: {
          objectFit: "cover",
          height: 130,
          width: 182,
          display: "block",
          boxShadow: theme.shadows[2],
          borderRadius: "6px",
          cursor: "pointer",
        },
        divider: {
          borderBottom: `1px solid #ECECEC`,
        },
        contactButton: {
          textTransform: "lowercase",
          display: "flex",
          marginBottom: theme.spacing(2.5),
          color: theme.palette.text.primary,
          "& .MuiSvgIcon-root": {
            color: theme.palette.primary.main,
          },
        },
        contactWrapper: {
          marginBottom: theme.spacing(1.25),
        },
        sectionTitle: {
          fontSize: theme.typography.subtitle1.fontSize,
          fontWeight: theme.typography.fontWeightBold,
          marginBottom: theme.spacing(2),
          color: theme.palette.text.primary,
        },
      },
    },
    AppImageModal: {
      styleOverrides: {
        root: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: theme.spacing(2),
        },
        imageWrapper: {
          position: "relative",
          outline: "none",
          maxWidth: "80vw",
          height: "60vh",
          "& img": {
            borderRadius: "8px",
            height: "100%",
          },
        },
        closeButton: {
          color: theme.palette.common.white,
          position: "absolute",
          top: theme.spacing(-4.5),
          right: theme.spacing(-1),
          [theme.breakpoints.up("sm")]: {
            right: theme.spacing(-2),
          },
        },
      },
    },
    AppYouAreHereMarker: {
      styleOverrides: {
        root: {
          "& .primary": {
            fill: theme.palette.primary.main,
          },
          "& .primary-light": {
            fill: theme.palette.secondary.main,
          },
          "& .primary-border": {
            stroke: theme.palette.primary.main,
          },
          "& .text-primary": {
            fill: theme.palette.text.primary,
          },
          "& .secondary": {
            fill: theme.palette.secondary.main,
          },
        },
      },
    },
    DirectionStep: {
      styleOverrides: {
        originIcon: {
          fill: theme.palette.primary.main,
          width: 37,
          height: 37,
        },
        destinationIcon: {
          fill: theme.palette.error.main,
          width: 28,
          height: 47,
        },
        highlightedText: {
          color: theme.palette.primary.main,
          textAlign: "inherit",
          fontWeight: 700,
          lineHeight: "inherit",
          fontSize: "inherit",
        },
      },
    },
    SkeletonDirectionOverviewSidebar: {
      styleOverrides: {
        root: {
          padding: theme.spacing(4, 4, 0),
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        },
        headerWrapper: {
          width: "100%",
          padding: theme.spacing(2),
          gap: theme.spacing(0.5),
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        },
        locationAvatar: {
          width: "80px",
          height: "80px",
        },
        locationText: {
          width: "60px",
        },
        durationText: {
          width: "134px",
        },
        contentWrapper: {
          fontWeight: 700,
          textAlign: "center",
          width: "100%",
          padding: theme.spacing(0, 2, 2),
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: theme.spacing(4),
        },
        qrCodeContainer: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        },
        qrCode: {
          width: "88px",
          height: "88px",
        },
        qrcodeText: {
          width: "76px",
          height: "20px",
        },
        stepContainer: {
          height: "auto",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "flex-start",
          gap: theme.spacing(1),
          marginTop: theme.spacing(2),
        },
        stepListContainer: {
          width: "364px",
          height: "216px",
        },
        actionContainer: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          marginTop: theme.spacing(4),
          gap: theme.spacing(3),
          width: "100%",
        },
        avoidStepButton: {
          width: "160px",
          height: "46px",
        },
        startButton: {
          width: "100%",
          height: "48px",
        },
      },
    },
    SkeletonStepByStepSidebar: {
      styleOverrides: {
        root: {
          padding: theme.spacing(4, 4, 0),
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        },
        stepContainer: {
          height: "auto",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "flex-start",
          gap: theme.spacing(1),
          marginTop: theme.spacing(0.5),
          marginRight: "auto",
        },
        stepItem: {
          height: "auto",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: theme.spacing(1.25),
        },
        locationAvatar: {
          width: "80px",
          height: "80px",
        },
        locationText: {
          width: "60px",
        },
        actionContainer: {
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          gap: theme.spacing(2),
          width: "100%",
          marginTop: theme.spacing(4),
        },
        button: {
          width: "174px",
          height: "48px",
        },
        stepProgressBarContainer: {},
        stepProgressBar: {
          height: "400px",
          width: "300px",
        },
      },
    },
    AppDirectionOverview: {
      styleOverrides: {
        root: {
          padding: theme.spacing(4, 4, 0),
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        },
        stepContainer: {
          height: "auto",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "flex-start",
          gap: theme.spacing(1),
          marginTop: theme.spacing(2),
        },
        stepListContainer: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(1),
          width: "100%",
          maxWidth: "364px",
          height: "216px",
          overflow: "hidden auto",
          padding: theme.spacing(0, 2),
          "&::-webkit-scrollbar": {
            width: "8px",
          },
          "::-webkit-scrollbar-track": {
            borderRadius: "8px",
            background: theme.palette.grey[300],
          },
          "::-webkit-scrollbar-thumb": {
            borderRadius: "8px",
            background: theme.palette.primary.main,
          },
          "::-webkit-scrollbar-thumb:hover": {
            background: theme.palette.primary.main,
          },
        },
        stepListItem: {
          padding: theme.spacing(1, 2),
          "& .step": {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            width: "40px",
            height: "40px",
            fontSize: "1.25rem",
            "& svg": {
              height: "24px",
              width: "24px",
            },
          },
          "& .StepByStepIcon-destination": {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            width: "40px",
            height: "40px",
            "& .MuiSvgIcon-root": {
              height: "24px",
              width: "24px",
            },
          },
        },
        stepListAvatarContainer: {
          minWidth: "56px",
        },
        stepListItemText: {
          "& .MuiListItemText-primary": {
            color: theme.palette.text.primary,
            fontSize: "0.875rem",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 4,
            WebkitBoxOrient: "vertical",
            whiteSpace: "normal",
            lineHeight: "normal",
            fontWeight: 400,
          },
          "& .MuiListItemText-secondary": {
            color: theme.palette.text.primary,
            fontSize: "0.75rem",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 4,
            WebkitBoxOrient: "vertical",
            whiteSpace: "normal",
            lineHeight: "normal",
            fontWeight: 400,
          },
        },
        ordinalSelector: {
          position: "fixed",
          bottom: "314px",
          right: "534px",
        },
        headerWrapper: {
          width: "100%",
          padding: theme.spacing(2),
          gap: theme.spacing(0.5),
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        },
        locationButtonContainer: {
          display: "none",
        },
        actionContainer: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          marginTop: theme.spacing(4),
          gap: theme.spacing(3),
          width: "100%",
        },
        avoidStepButton: {
          "& .MuiFormControlLabel-label": {
            textTransform: "uppercase",
            fontSize: "1.125rem",
            fontWeight: 600,
          },
          marginRight: 0,
          flexDirection: "row-reverse",
        },
        primaryButton: {},
        playerActionContainer: {
          display: "none",
        },
        contentWrapper: {
          fontWeight: 700,
          textAlign: "center",
          width: "100%",
          padding: theme.spacing(0, 2, 2),
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: theme.spacing(4),
        },
        durationText: {},
        qrcodeText: {
          textTransform: "uppercase",
          fontSize: "0.625rem",
        },
        qrCodeContainer: {},
        qrCode: {
          marginBottom: theme.spacing(1),
        },
        startButton: {
          fontSize: "1rem",
          height: 48,
        },
        sidebarContent: {},
      },
    },
    DirectionCardActions: {
      styleOverrides: {
        root: {
          gap: theme.spacing(2),
          height: "auto",
          padding: 0,
          display: "flex",
          flexDirection: "row",
        },
        actionButton: {
          [theme.breakpoints.down("sm")]: {
            fontWeight: 700,
            "&.MuiButton-outlined": {
              border: `1px solid ${theme.palette.grey[400]} `,
            },
            "& .MuiButton-startIcon": {
              marginRight: theme.spacing(1.25),
            },
          },
        },
      },
    },
    HomePage: {
      styleOverrides: {
        root: {
          top: 0,
          padding: theme.spacing(5),
          backgroundColor: theme.palette.background.default,
        },
        contentContainer: {
          height: "100%",
          display: "flex",
          flexDirection: "row",
          gap: theme.spacing(3),
        },
        welcomePanelWrapper: {
          width: "400px",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          background: theme.palette.background.paper,
          borderRadius: "32px",
        },
        welcomeContainer: {
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          padding: theme.spacing(10, 0),
          gap: theme.spacing(30),
        },
        logoContainer: {},
        logoImage: {
          height: 80,
        },
        qrContainer: {
          display: "none",
        },
        qrCode: {
          paddingTop: theme.spacing(4),
          backgroundColor: "transparent",
          "& .AppQRCode-content": {
            width: 80,
            height: 80,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            border: "none",
            //create corner border
            //https://stackoverflow.com/questions/38850419/how-to-create-multi-color-border-with-css
            //http://www.java2s.com/example/html-css/css-widget/add-border-only-to-corner.html
            ":before": {
              content: "''",
              display: "block",
              position: "absolute",
              borderTop: "3px solid",
              borderBottom: "3px solid",
              borderImage:
                "linear-gradient(to right, black 25%, transparent 25%, transparent 50%,transparent 50%, transparent 75%, black 75%) 3",
              height: 80,
              width: 80,
            },
            ":after": {
              display: "block",
              position: "absolute",
              content: "''",
              borderRight: "3px solid",
              borderLeft: "3px solid",
              borderImage:
                "linear-gradient(to bottom, black 25%, transparent 25%, transparent 50%,transparent 50%, transparent 75%, black 75%) 3",
              height: 80,
              width: 80,
            },
          },
          "& .AppQRCode-qrcode": {
            height: 65,
            width: 65,
            border: "none",
          },
          "& .AppQRCode-caption": {
            paddingTop: theme.spacing(2),
            fontWeight: 500,
            fontSize: "0.875rem",
            color: theme.palette.text.secondary,
          },
        },
        localeListContainer: {
          display: "none",
        },
        localeButton: {
          borderRadius: "50%",
          height: "40px",
          width: "40px",
          padding: 0,
          minWidth: 40,
          boxShadow: theme.shadows[3],
          "& .MuiAvatar-circular": {
            height: "35px",
            width: "35px",
          },
        },
        actionContainer: {
          position: "relative",
          display: "inline-block",
          "&:after, :before": {
            opacity: 0,
            display: "flex",
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            content: '""',
            height: "100%",
            width: "100%",
            border: `2px solid ${alpha(theme.palette.primary.light, 0.7)}`,
            borderRadius: 9999,
            zIndex: -1,
          },
          "&:after": {
            animation: `ripple 2s infinite ${theme.transitions.easing.easeInOut}`,
          },
          "&:before": {
            animation: `ripple 2s infinite ${theme.transitions.easing.easeInOut} 0.3s`,
          },
        },
        actionButton: {
          display: "none",
        },
        homeActionButton: {},
        videoContainer: {
          display: "none",
        },
        screensaverContainer: {
          borderRadius: "32px",
          width: "1410px",
          height: "100%",
          background: theme.palette.common.black,
        },
        carouselWrapper: {
          display: "none",
        },
        carouselScreenSaver: {},
        carouselMediaItem: {},
      },
    },
    FullScreenStart: {
      styleOverrides: {
        root: {
          display: "none",
        },
        actionButtonWrapper: {
          position: "relative",
          display: "inline-block",
          "&:after, :before": {
            opacity: 0,
            display: "flex",
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            content: '""',
            height: "100%",
            width: "100%",
            border: `5px solid ${alpha(theme.palette.common.white, 0.4)} `,
            borderRadius: 9999,
            zIndex: -1,
          },
          "&:after": {
            animation: `ripple 3s infinite ${theme.transitions.easing.easeInOut} `,
          },
          "&:before": {
            animation: `ripple 3s infinite ${theme.transitions.easing.easeInOut} 0.5s`,
          },
        },
        actionButton: {
          position: "relative",
          fontSize: "1rem",
          textTransform: "uppercase",
          color: theme.palette.text.secondary,
          fontWeight: 700,
          borderRadius: 999,
          backgroundColor: theme.palette.common.white,
          transition: theme.transitions.create("all"),
          boxShadow: theme.shadows[10],
          padding: theme.spacing(1.25, 3),
          "&:hover": {
            boxShadow: theme.shadows[20],
            backgroundColor: theme.palette.common.white,
            paddingLeft: theme.spacing(4),
            paddingRight: theme.spacing(4),
          },
          "& .MuiButton-startIcon>svg": {
            fontSize: "1.5rem",
            color: theme.palette.primary.main,
          },
          [theme.breakpoints.up("md")]: {
            transform: "scale(1.2)",
          },
        },
      },
    },
    DirectoryPage: {
      styleOverrides: {
        root: {
          "& .MuiList-root": {
            display: "none",
          },
          display: "flex",
          flexDirection: "column-reverse",
          gap: theme.spacing(1),
          margin: theme.spacing(0, -3),
        },
        filterSection: {
          position: "relative",
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(3),
          top: 0,
          zIndex: 1,
          paddingTop: theme.spacing(3.75),
          "& .category-filterbar,& .subCategory-filterbar": {
            padding: theme.spacing(0, 1.5),
            position: "relative",
            maxWidth: "95%",
            margin: "0 auto",
            "&:after": {
              content: "''",
              display: "inline-block",
              width: "20px",
              background:
                "linear-gradient(90deg, rgba(255, 255, 255, 0.00) 10%, #fff 90%)",
              zIndex: 1,
              position: "absolute",
              right: "2px",
              top: 0,
              bottom: 0,
            },
            "&:before": {
              content: "''",
              display: "inline-block",
              width: "20px",
              background:
                "linear-gradient(90deg, #fff 10%, rgba(255, 255, 255, 0.00) 90%)",
              zIndex: 1,
              position: "absolute",
              left: "2px",
              top: 0,
              bottom: 0,
            },
          },
          "& .category-filterbar": {
            order: 0,
          },
          "& .subCategory-filterbar": {
            order: 1,
          },
        },
        categoryFilterBar: {
          gap: theme.spacing(5),
          padding: theme.spacing(0.25, 0),
          margin: "0 auto",
          "& .MuiToggleButton-root:first-of-type": {
            marginLeft: theme.spacing(0),
          },
          "& .MuiToggleButton-root:last-of-type": {
            marginRight: theme.spacing(0),
          },
        },
        subCategoryFilterBar: {
          gap: theme.spacing(2),
          margin: `0 auto ${theme.spacing(3)} `,
          "& .MuiToggleButton-root": {
            height: "48px",
            "& .MuiSvgIcon-root": {
              display: "none",
            },
          },
          "& .MuiToggleButton-root.MuiToggleButtonGroup-grouped:first-of-type":
            {
              marginLeft: 0,
            },
          "& .MuiToggleButton-root:last-of-type": {
            marginRight: 0,
          },
        },
        scrollPane: {
          padding: 0,
        },
        buildingWithLevelFilterSection: {
          display: "none",
          "& .MuiToggleButtonGroup-root": {
            gap: theme.spacing(1),
          },
          "& .MuiDivider-root": {
            display: "none",
          },
        },
        buildingFilterSelect: {
          flex: "6 0 0",
        },
        levelFilterSelect: {
          flex: "4 0 0",
        },
        selectMenuItem: {
          fontSize: "0.75rem",
        },
        resetButton: {
          color: theme.palette.info.main,
          textDecoration: "underline",
          fontSize: "0.75rem",
        },
        divider: {
          display: "none",
        },
        list: {
          padding: theme.spacing(0, 1),
          paddingTop: theme.spacing(1),
        },
        gridContainer: {
          position: "relative",
          display: "grid",
          gridAutoFlow: "dense",
          gridAutoRows: "max-content",
          gridTemplateColumns: "repeat(4,  minmax(100px,1fr))",
          gap: theme.spacing(2),
          overflowY: "auto",
          height: "588px",
          padding: theme.spacing(0, 5, 5),
          //hide scrollbar
          "::-webkit-scrollbar": {
            display: "none",
          },
          MsOverflowStyle: "none",
          scrollbarWidth: "none",
          "&.emptyList": {
            height: "100%",
          },
        },
        gridItem: {},
        emptyDataWrapper: {
          position: "absolute",
          left: "50%",
          top: "50%",
          transform: "translate(-50%, -50%)",
          width: "370px",
        },
        pageCard: {
          "&:after": {
            content: "''",
            pointerEvents: "none",
            display: "inline-block",
            position: "absolute",
            zIndex: 1,
            left: 0,
            right: 0,
            bottom: theme.spacing(26.25),
            minHeight: "180px",
            background:
              "linear-gradient(0deg, #FFF 2.8%, rgba(255, 255, 255, 0.00) 50%)",
          },
        },
      },
    },
    LevelFilterBar: {
      styleOverrides: {
        root: {
          padding: 0,
          "& .MuiToggleButton-root": {
            padding: theme.spacing(1, 3),
            flexShrink: 0,
          },
          "& .MuiToggleButton-root:first-of-type": {
            marginLeft: theme.spacing(3),
          },
          "& .MuiToggleButton-root:last-of-type": {
            marginRight: theme.spacing(3),
          },
        },
      },
    },
    DirectoryOccupantCard: {
      styleOverrides: {
        root: {
          boxShadow: "none",
          display: "flex",
          height: "128px",
          borderRadius: "8px",
          border: `1px solid ${theme.palette.divider}`,
        },
        primaryCoverAvatar: {},
        secondaryCoverAvatar: {
          display: "none",
        },
        occupantLogo: {
          boxShadow: "none",
          width: "100%",
          minWidth: "128px",
          maxWidth: "128px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          "& .MuiAvatar-root": {
            borderRadius: "0",
            width: "100%",
            height: "100%",
          },
          "& .MuiSvgIcon-root": {
            width: "48px",
            height: "48px",
          },
        },
        cardContent: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          width: "100%",
          "& .MuiTypography-root": {
            lineHeight: 1.25,
          },
        },
        levelContainer: {
          background: alpha(theme.palette.primary.main, 0.2),
          width: "28px",
          height: "28px",
          color: theme.palette.primary.main,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "4px",
          "& .MuiTypography-root": {
            fontSize: "0.75rem",
          },
        },
        divider: {
          margin: theme.spacing(0, 1.625),
        },
        venueLogo: {
          display: "none",
        },
        titleText: {
          fontSize: "1rem",
          fontWeight: 700,
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 2,
          overflow: "hidden",
          color: theme.palette.text.primary,
        },
        groupText: {
          fontSize: "0.75rem",
          fontWeight: 300,
          display: "none",
        },
        categoryText: {
          fontSize: "0.75rem",
          fontWeight: 300,
          color: theme.palette.text.primary,
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 1,
          overflow: "hidden",
        },
        titleContainer: {
          height: "100%",
          padding: theme.spacing(0.875, 1.625, 0),
          maxWidth: "204px",
        },
        detailWrapper: {
          height: "100%",
          justifyContent: "space-between",
          padding: theme.spacing(0, 1.25, 1.25, 0),
        },
        locationInfoContainer: {
          paddingLeft: theme.spacing(1.625),
          paddingBottom: theme.spacing(0.875),
          color: theme.palette.text.secondary,
        },
        boothText: {
          overflow: "hidden",
          fontSize: "0.75rem",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          display: "none",
        },
        chip: {
          backgroundColor: theme.palette.grey[300],
          fontSize: "0.75rem",
          fontWeight: 400,
          borderRadius: "4px",
          height: "20px",
          padding: theme.spacing(0.5),
          "& .MuiChip-label": {
            padding: theme.spacing(0),
          },
        },
      },
    },
    DirectorySkeletonCard: {
      styleOverrides: {
        root: {
          boxShadow: "none",
          display: "flex",
          height: "96px",
          borderRadius: "8px",
        },
        avatar: {
          boxShadow: theme.shadows[1],
          height: "100%",
          width: "100%",
          maxWidth: "96px",
        },
        logo: {
          boxShadow: "none",
        },
        cardContent: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          width: "100%",
          padding: theme.spacing(0.875, 1.625),
        },
        divider: {
          display: "none",
          height: "1px",
          margin: theme.spacing(0, 1.625),
        },
        primaryText: {
          fontSize: "1rem",
        },
        secondaryText: {
          fontSize: "0.875rem",
        },
      },
    },
    PromotionPage: {
      defaultProps: {
        promotionCarouselOption: {
          limitPaginations: 7,
        },
      },
      styleOverrides: {
        root: {
          position: "absolute",
          overflow: "hidden",
          left: 0,
          right: 0,
          height: "calc(100vh - 285px - 300px)", //100vh - (kiosk header) - (kiosk footer)
          top: "206px",
        },
        carouselContainer: {
          display: "flex",
          flexDirection: "column",
          position: "relative",
          width: "1276px",
          alignItems: "center",
          justifyContent: "center",
          flexGrow: 1,
        },
        categoryFilterBarContainer: {},
        cardListContainer: {
          display: "none",
        },
        carousel: {
          width: "100%",
          "& .splide": {
            margin: "0 auto",
          },
          "& .splide__pagination": {
            marginTop: "50px",
          },
          "& .splide__pagination__page": {
            width: "14px",
            height: "14px",
          },
          "& .splide__pagination__page.is-active": {
            backgroundColor: theme.palette.primary.main,
            transition: `width ${theme.transitions.duration.short}ms ${theme.transitions.easing.easeInOut}, borderRadius ${theme.transitions.duration.standard}s ${theme.transitions.easing.easeInOut} `,
            transform: "none",
            width: 45,
            borderRadius: 30,
          },
          "& .splide__track": {
            margin: theme.spacing(-3.75),
            padding: theme.spacing(0, 3.75),
          },
          "& .splide__slide": {
            "&> *": {
              display: "inline-block",
              transform: "scale(0.85)",
              opacity: 0.4,
              transition: `all ${theme.transitions.duration.short} ms`,
            },
            "&.is-visible.is-active": {
              "&> *": {
                opacity: 1,
                transform: "scale(1)",
              },
            },
          },
        },
        promotionCard: {
          minHeight: "auto",
          width: "400px",
        },
        emptyDataWrapper: {
          width: "370px",
        },
        subCategoryFilterBar: {
          position: "absolute",
          left: "50%",
          zIndex: 2,
          transform: "translateX(-50%)",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          bottom: 0,
          width: "100%",
          maxWidth: "84%",
          marginBottom: theme.spacing(3),
          "&:after": {
            content: "''",
            display: "inline-block",
            width: "20px",
            background:
              "linear-gradient(90deg, rgba(255, 255, 255, 0.00) 10%, #fff 90%)",
            zIndex: 1,
            position: "absolute",
            right: "-4px",
            top: 0,
            bottom: 0,
          },
          "&:before": {
            content: "''",
            display: "inline-block",
            width: "20px",
            background:
              "linear-gradient(90deg, #fff 10%, rgba(255, 255, 255, 0.00) 90%)",
            zIndex: 1,
            position: "absolute",
            left: "-4px",
            top: 0,
            bottom: 0,
          },
          "& .MuiToggleButton-root": {
            "& .MuiSvgIcon-root": {
              display: "none",
            },
          },
          "& .MuiToggleButtonGroup-root": {
            gap: theme.spacing(1),
            paddingLeft: theme.spacing(2),
            margin: "0 auto",
          },
          "& .MuiToggleButton-root:first-of-type": {
            marginLeft: 0,
          },
          "& .MuiToggleButton-root:last-of-type": {
            marginRight: 0,
          },
        },
        scrollPane: {
          padding: 0,
        },
        pageCardContent: {
          display: "flex",
          flexDirection: "column",
        },
        promotionGroupSelectorButton: {
          position: "absolute",
          left: "50%",
          zIndex: 2,
          transform: "translateX(-50%)",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          bottom: 0,
          width: "100%",
          maxWidth: "84%",
          marginBottom: theme.spacing(7.75),
          "&:after": {
            content: "''",
            display: "inline-block",
            width: "20px",
            background:
              "linear-gradient(90deg, rgba(255, 255, 255, 0.00) 10%, #fff 90%)",
            zIndex: 1,
            position: "absolute",
            right: "-4px",
            top: 0,
            bottom: 0,
          },
          "&:before": {
            content: "''",
            display: "inline-block",
            width: "20px",
            background:
              "linear-gradient(90deg, #fff 10%, rgba(255, 255, 255, 0.00) 90%)",
            zIndex: 1,
            position: "absolute",
            left: "-4px",
            top: 0,
            bottom: 0,
          },
          "& .MuiToggleButton-root": {
            padding: theme.spacing(2, 4),
            height: "50px",
            width: "194px",
            "& .MuiSvgIcon-root": {
              display: "none",
            },
          },
          "& .MuiToggleButtonGroup-root": {
            gap: theme.spacing(1.5),
            paddingLeft: theme.spacing(2),
            margin: "0 auto",
          },
          "& .MuiToggleButton-root:first-of-type": {
            marginLeft: 0,
          },
          "& .MuiToggleButton-root:last-of-type": {
            marginRight: 0,
          },
        },
      },
    },
    PromotionDetailPage: {
      defaultProps: {
        promotionCarouselOption: {
          limitPaginations: 7,
        },
      },
      styleOverrides: {
        titleText: {
          fontWeight: 700,
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          textAlign: "center",
        },
        descriptionText: {
          maxHeight: "288px",
          height: "100%",
          color: theme.palette.text.secondary,
          overflow: "hidden auto",
          padding: theme.spacing(1.5, 4, 0),
          "&::-webkit-scrollbar": {
            width: "8px",
          },
          "::-webkit-scrollbar-track": {
            borderRadius: "8px",
            background: theme.palette.grey[300],
          },
          "::-webkit-scrollbar-thumb": {
            borderRadius: "8px",
            background: theme.palette.primary.main,
          },
          "::-webkit-scrollbar-thumb:hover": {
            background: theme.palette.primary.main,
          },
        },
        detailContainer: {
          padding: theme.spacing(5, 4, 3),
          height: "100%",
          display: "flex",
          flexDirection: "column",
        },
        locationButton: {
          marginTop: theme.spacing(3),
          textTransform: "capitalize",
          padding: theme.spacing(1.5, 3),
          fontWeight: 700,
        },
        qrCode: {
          marginBottom: theme.spacing(1),
        },
        infoListItem: {
          overflow: "hidden",
          maxWidth: "90%",
          "& .MuiTypography-root": {
            overflow: "hidden",
            textOverflow: "ellipsis",
            WebkitLineClamp: 1,
            WebkitBoxOrient: "vertical",
          },
          "& .MuiListItemText-root": {
            margin: 0,
          },
        },
        locationButtonContainer: {
          flexGrow: 1,
          display: "flex",
          flexDirection: "column-reverse",
        },
        listItemContainer: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(1),
          padding: theme.spacing(1),
          width: "216px",
        },
        infoContainer: {
          marginTop: theme.spacing(3),
          display: "flex",
          flexDirection: "row",
          gap: theme.spacing(3),
          padding: theme.spacing(3),
        },
        qrcodeText: {
          textTransform: "uppercase",
          textAlign: "center",
          fontSize: "0.625rem",
        },
        headerContainer: {
          display: "flex",
          flexDirection: "row",
          gap: theme.spacing(2),
          alignItems: "center",
        },
        avatarRoot: {
          margin: 0,
          width: "80px",
          height: "80px",
          borderRadius: "8px",
          fontSize: "3rem",
          boxShadow: `0px 8px 24px 0px rgba(155, 155, 155, 0.15)`,
        },
        titleContainer: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(0.5),
        },
        locationTitle: {
          fontSize: "3rem",
          fontWeight: "700",
          overflow: "hidden",
          maxWidth: "600px",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 1,
          WebkitBoxOrient: "vertical",
          lineHeight: 1,
        },
        locationSubTitle: {
          fontSize: "1.5rem",
          fontWeight: "400",
        },
        sidebarContent: {},
        titleConnectorIcon: {
          display: "none",
          width: "24px",
          height: "24px",
        },
      },
    },
    OccupantPromotionPage: {
      defaultProps: {
        promotionCarouselOption: {},
      },
      styleOverrides: {
        headerContainer: {
          display: "flex",
          flexDirection: "column",
          gap: 2.25,
        },
        headerLogoWrapper: { width: 120 },
        headerLogo: { width: "100%" },
        headerText: {
          fontWeight: 400,
          fontSize: "2rem",
        },
        contentContainer: {
          padding: theme.spacing(4, 10),
          display: "flex",
          flexDirection: "column",
          gap: 7.5,
          height: "100%",
        },
        gridContainer: {
          display: "grid",
          gridAutoRows: "320px",
          gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
          columnGap: 5,
          rowGap: theme.spacing(3),
          paddingBottom: theme.spacing(7.5),
          overflowY: "scroll",
          flex: "1 1 1",
          "&:after": {
            content: "''",
            pointerEvents: "none",
            display: "inline-block",
            position: "absolute",
            zIndex: 1,
            left: 0,
            right: 0,
            bottom: 0,
            minHeight: "180px",
            background:
              "linear-gradient(0deg, #FFF 37.46%, rgba(255, 255, 255, 0.00) 94.07%)",
          },
        },
      },
    },
    FeatureActionContainer: {
      styleOverrides: {
        shortInfoActionWrapper: {
          "button, a": {
            pointerEvents: "all",
          },
          [theme.breakpoints.up("sm")]: {
            paddingBottom: theme.spacing(3),
          },
        },
      },
    },
    EventPage: {
      defaultProps: {
        eventCarouselOption: {
          limitPaginations: 7,
          gap: theme.spacing(4),
          fixedWidth: "483px",
        },
        eventLayoutType: "carousel",
        eventDisplayMode: "all",
      },
      styleOverrides: {
        gridContainer: {
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)",
          rowGap: theme.spacing(4),
          paddingBottom: theme.spacing(4),
        },
        pageCard: {},
        pageCardContent: {
          display: "flex",
          "&.EventLayoutType-carousel": {
            padding: theme.spacing(3, 0),
          },
          "&.EventLayoutType-grid": {
            padding: theme.spacing(3, 12, 0, 12),
          },
          "&.EventDisplayMode-grouped": {
            "& .VerticalEventCard-comingSoonChip": {
              display: "none",
            },
          },
        },
        carouselContainer: {
          position: "relative",
          top: 0,
          left: 0,
          right: 0,
          display: "flex",
          flexGrow: 1,
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          "&:before": {
            content: "''",
            position: "absolute",
            width: "65px",
            height: "100%",
            background:
              "linear-gradient(90deg, rgba(256, 256, 256, 1) 0%, rgba(256, 256, 256, 0) 100%)",
            left: 0,
            zIndex: 1,
          },
          "&:after": {
            content: "''",
            position: "absolute",
            width: "65px",
            height: "100%",
            background:
              "linear-gradient(-90deg, rgba(256, 256, 256, 1) 0%, rgba(256, 256, 256, 0) 100%)",
            right: 0,
            zIndex: 1,
          },
        },
        carousel: {
          width: "100%",
          "& .splide__pagination__page": {
            width: "16px",
            height: "16px",
          },
          "& .splide__pagination__page.is-active": {
            width: "20px",
            height: "20px",
            backgroundColor: theme.palette.primary.main,
            borderRadius: 30,
            transition: `width ${theme.transitions.duration.short}ms ${theme.transitions.easing.easeInOut}, borderRadius ${theme.transitions.duration.standard}s ${theme.transitions.easing.easeInOut} `,
            transform: "none",
          },
          "& .splide__track": {
            margin: 0,
            padding: theme.spacing(0, 3.75, 1.5, 3.75),
          },
          "& .splide__slide": {
            "&> *": {
              display: "inline-block",
              transform: "scale(1)",
              opacity: 1,
              transition: `all ${theme.transitions.duration.short}ms`,
            },
            "&.is-visible.is-active": {
              "&> *": {
                opacity: 1,
                transform: "scale(1)",
              },
            },
          },
        },
        // TODO: will style with all empty page
        emptyDataWrapper: {
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginTop: 0,
        },
        venueSelector: {
          display: "none",
          position: "absolute",
          left: "50%",
          bottom: "-2px",
          transform: "translate(-50%, -50%)",
        },
        eventGroupSelectorButton: {
          // display: "none",
          display: "flex",
          position: "absolute",
          left: "50%",
          zIndex: 2,
          transform: "translateX(-50%)",
          flexDirection: "row",
          justifyContent: "center",
          bottom: 0,
          width: "100%",
          maxWidth: "84%",
          marginBottom: theme.spacing(3),
          "& .MuiToggleButton-root": {
            padding: theme.spacing(2, 4),
            height: "50px",
            width: "194px",
            "& .MuiSvgIcon-root": {
              display: "none",
            },
          },
          "& .MuiToggleButtonGroup-root": {
            gap: theme.spacing(1.5),
            paddingLeft: theme.spacing(2),
            margin: "0 auto",
          },
          "& .MuiToggleButton-root:first-of-type": {
            marginLeft: 0,
          },
          "& .MuiToggleButton-root:last-of-type": {
            marginRight: 0,
          },
        },
      },
    },
    EventDetailPage: {
      defaultProps: {
        eventCarouselOption: {
          limitPaginations: 7,
        },
        galleryCarouselOption: {
          limitPaginations: 7,
        },
      },
      styleOverrides: {
        titleText: {
          fontWeight: 700,
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          textAlign: "center",
        },
        descriptionText: {
          maxHeight: "248px",
          height: "100%",
          color: theme.palette.text.secondary,
          overflow: "hidden auto",
          padding: theme.spacing(1.5, 4, 0),
          "&::-webkit-scrollbar": {
            width: "8px",
          },
          "::-webkit-scrollbar-track": {
            borderRadius: "8px",
            background: theme.palette.grey[300],
          },
          "::-webkit-scrollbar-thumb": {
            borderRadius: "8px",
            background: theme.palette.primary.main,
          },
          "::-webkit-scrollbar-thumb:hover": {
            background: theme.palette.primary.main,
          },
        },
        detailContainer: {
          padding: theme.spacing(5, 4, 3),
          height: "100%",
          display: "flex",
          flexDirection: "column",
        },
        locationButton: {
          marginTop: theme.spacing(2),
          textTransform: "capitalize",
          padding: theme.spacing(1.5, 3),
          fontWeight: 700,
        },
        qrCode: {
          marginBottom: theme.spacing(1),
        },
        infoListItem: {
          overflow: "hidden",
          maxWidth: "90%",
          "& .MuiTypography-root": {
            overflow: "hidden",
            textOverflow: "ellipsis",
            WebkitLineClamp: 1,
            WebkitBoxOrient: "vertical",
          },
          "& .MuiListItemText-root": {
            margin: 0,
          },
        },
        locationButtonContainer: {
          flexGrow: 1,
          display: "flex",
          flexDirection: "column-reverse",
        },
        listItemContainer: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(1),
          padding: theme.spacing(1),
          width: "216px",
        },
        infoContainer: {
          display: "flex",
          flexDirection: "row",
          gap: theme.spacing(3),
          padding: theme.spacing(2, 3),
        },
        qrcodeText: {
          textTransform: "uppercase",
          textAlign: "center",
          fontSize: "0.625rem",
        },
        galleryCarousel: {
          width: 280,
          "& .splide__track": {
            margin: 0,
            padding: 0,
            borderRadius: "10px",
          },
          "& .splide__pagination__page": {
            marginTop: theme.spacing(1.5),
            width: "8px",
            height: "8px",
          },
          "& .splide__pagination__page.is-active": {
            backgroundColor: theme.palette.secondary.main,
            transition: `width ${theme.transitions.duration.short}ms ${theme.transitions.easing.easeInOut}, borderRadius ${theme.transitions.duration.standard}s ${theme.transitions.easing.easeInOut} `,
            transform: "none",
            width: "47.25px",
            borderRadius: "35px",
          },
        },
        galleryCarouselImage: {
          width: "100%",
          height: "150px",
          objectFit: "cover",
          borderRadius: "10px",
        },
        galleryCarouselItem: {},
        galleryContainer: {
          display: "flex",
          justifyContent: "center",
        },
        sidebarContent: {},
      },
    },
    /**
     * TODO:
     * dynamic CSS
     * provide width, height or ratio and compute the CSS for `VerticalEventCard`
     * reusable mixin?
     */
    VerticalEventCard: {
      styleOverrides: {
        root: {
          width: "483px",
          borderRadius: "24px",
          background: theme.palette.background.paper,
          border: `1px solid ${theme.palette.grey[200]}`,
          display: "flex",
          flexDirection: "column",
          boxShadow:
            "0 16px 5px 0 rgba(0, 0, 0, 0.00), 0 11px 4px 0 rgba(0, 0, 0, 0.01), 0 6px 4px 0 rgba(0, 0, 0, 0.02), 0 3px 3px 0 rgba(0, 0, 0, 0.03), 0 1px 1px 0 rgba(0, 0, 0, 0.04)",
          "&.EventLayoutType-grid": {
            width: "279px",
          },
        },
        cardMedia: {
          height: "100%",
          width: "483px",
          aspectRatio: "47/70",
          objectFit: "cover",
          position: "relative",
          "&.EventLayoutType-grid": {
            width: "279px",
          },
        },
        cardContent: {
          padding: theme.spacing(2),
          gap: theme.spacing(1),
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          height: "190px",
          position: "relative",
          "&.EventLayoutType-grid": {
            height: "152px",
          },
          "&.MuiCardContent-root:last-child": {
            padding: theme.spacing(2),
          },
          "& .MuiTypography-root": {
            fontSize: "1rem",
          },
        },
        cardContentStack: {},
        venueLogoContainer: {
          display: "none",
          position: "absolute",
          bottom: "16px",
          right: "16px",
          "& .MuiCardMedia-root": {
            maxWidth: "90px",
            maxHeight: "43px",
          },
          "&.EventLayoutType-grid": {
            bottom: "12px",
            right: "12px",
            "& .MuiCardMedia-root": {
              maxHeight: "22px",
            },
          },
        },
        chipContainer: {
          display: "flex",
          gap: theme.spacing(0.5),
        },
        highlightChip: {
          "&.EventLayoutType-grid": {
            height: "20px",
            padding: theme.spacing(0.5, 1),
            "& .MuiChip-label": {
              fontSize: "0.7rem",
            },
          },
        },
        comingSoonChip: {
          "&.EventLayoutType-grid": {
            height: "20px",
            padding: theme.spacing(0.5, 1),
            "& .MuiChip-label": {
              fontSize: "0.7rem",
            },
          },
        },
        durationContainer: {},
        duration: {
          color: theme.palette.text.secondary,
          "&.EventLayoutType-grid": {
            fontSize: "0.7rem",
          },
        },
        cardTitle: {
          fontWeight: 600,
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          wordBreak: "break-word",
          "&.MuiTypography-root": {
            color: theme.palette.grey[800],
            fontSize: "1.25rem",
            fontWeight: 700,
            lineHeight: "112%",
            "&.EventLayoutType-grid": {
              fontSize: "0.825rem",
            },
          },
        },
        cardInfoContainer: {
          display: "flex",
          flexDirection: "row",
          alignItems: "end",
          "& .MuiTypography-root": {
            color: theme.palette.text.secondary,
            fontSize: "1rem",
          },
        },
        iconContainer: {
          width: "24px",
          height: "24px",
          marginRight: theme.spacing(1),
          "&.EventLayoutType-grid": {
            width: "16px",
            height: "16px",
            marginRight: theme.spacing(0.5),
          },
          "& .MuiSvgIcon-root": {
            color: theme.palette.grey[600],
            width: "100%",
            height: "auto",
          },
        },
        locationInfo: {
          "&.MuiTypography-root": {
            "&.EventLayoutType-grid": {
              fontSize: "0.7rem",
            },
          },
        },
      },
    },
    ImageCard: {
      styleOverrides: {
        root: {},
        chipContainer: {
          position: "absolute",
          padding: "3%",
          right: 0,
          top: 0,
          zIndex: 1,
        },
        chip: {
          height: "30px",
          padding: theme.spacing(0.75, 1),
          fontSize: "0.875rem",
          fontWeight: 500,
          backgroundColor: theme.palette.error.main,
          borderRadius: "50px",
          color: theme.palette.error.contrastText,
        },
      },
    },
    ImageSkeletonCard: {
      styleOverrides: {
        root: {
          aspectRatio: "1 / 1",
          width: "100%",
          height: "100%",
        },
      },
    },
    PromotionCard: {
      styleOverrides: {
        root: {
          minHeight: "486px",
          width: "500px",
          borderRadius: "10px",
          boxShadow: theme.shadows[1],
          padding: 0,
          display: "flex",
          flexDirection: "column",
        },
        cardMedia: {
          height: "400px",
          maxHeight: "none",
          width: "100%",
          borderRadius: "none",
          objectFit: "cover",
          position: "relative",
        },
        cardContent: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          padding: theme.spacing(2, 2, 3),
          "&:last-child": {
            paddingBottom: theme.spacing(3),
          },
          [theme.breakpoints.up("sm")]: {
            padding: theme.spacing(2, 2, 3),
          },
        },
        durationContainer: {
          "& .MuiTypography-root": {
            fontSize: "1rem",
          },
        },
        venueLogoContainer: {
          display: "none",
          "& .MuiCardMedia-root": {
            maxWidth: "120px",
          },
        },
        venueLogo: {},
        cardContentStack: {},
        cardTitle: {
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          color: theme.palette.text.primary,
          fontSize: "1rem",
          wordBreak: "break-word",
        },
        cardInfoContainer: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          color: theme.palette.grey[700],
          fontSize: theme.typography.subTitle.fontSize,
        },
        iconContainer: {
          width: "auto",
          marginRight: theme.spacing(1),
          "& .MuiSvgIcon-root": {
            height: 14,
            color: theme.palette.primary.main,
          },
        },
        recommendText: {
          width: "100%",
          backgroundColor: theme.palette.primary.main,
          position: "absolute",
          bottom: 0,
          left: 0,
          borderRadius: "4px 4px 0px 0px",
          textAlign: "center",
          color: theme.palette.primary.contrastText,
        },
        chipContainer: { display: "none" },
        recommendTextContainer: {},
      },
    },
    HighlightFeatureCard: {
      styleOverrides: {
        root: {
          boxShadow: theme.shadows[1],
          borderRadius: `${(theme.shape.borderRadius * 2) / 3}px`,
          display: "flex",
          flexDirection: "row",
          height: 136,
          padding: theme.spacing(1.5, 1.375),
        },
        cardMedia: {
          width: 74,
          maxHeight: 164,
          borderRadius: "5px",
          objectFit: "cover",
          [theme.breakpoints.up("sm")]: {
            width: 95,
          },
        },
        cardContent: {
          padding: theme.spacing(1.375, 0, 1.375, 3),
          "&:last-child": {
            paddingBottom: theme.spacing(1),
            [theme.breakpoints.up("sm")]: {
              padding: theme.spacing(1, 1, 1, 3),
            },
          },
        },
        contentWrapper: {
          height: "100%",
          justifyContent: "space-between",
        },
        cardTitle: {
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          color: theme.palette.text.primary,
          wordBreak: "break-word",
        },
        cardInfoItem: {
          display: "flex",
          flexDirection: "row",
          color: theme.palette.text.secondary,
          "& .MuiTypography-root": {
            fontSize: "0.875rem",
            fontWeight: 500,
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 1,
            WebkitBoxOrient: "vertical",
          },
        },
        iconWrapper: {
          width: "auto",
          marginRight: theme.spacing(1),
          "& .MuiSvgIcon-root": {
            height: 14,
            color: theme.palette.primary.main,
          },
        },
      },
    },
    ListPromotionItemCard: {
      styleOverrides: {
        root: {
          boxShadow: theme.shadows[1],
          borderRadius: `${(theme.shape.borderRadius * 2) / 3}px`,
          display: "flex",
          flexDirection: "row",
          height: 104,
          padding: theme.spacing(1, 0.5),
        },
        cardMedia: {
          width: 88,
          maxHeight: 88,
          borderRadius: "5px",
          objectFit: "cover",
          [theme.breakpoints.up("sm")]: {
            width: 95,
          },
        },
        cardContent: {
          padding: theme.spacing(0.5, 1, 0.5, 2),
          "&:last-child": {
            paddingBottom: theme.spacing(0.5),
            [theme.breakpoints.up("sm")]: {
              padding: theme.spacing(0.5, 1, 0.5, 2),
            },
          },
        },
        contentWrapper: {
          height: "100%",
          gap: theme.spacing(2),
          justifyContent: "space-between",
        },
        cardTitle: {
          fontWeight: 600,
          fontSize: "14px",
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          color: theme.palette.text.primary,
          wordBreak: "break-word",
        },
        promotionInfoItem: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          color: theme.palette.text.secondary,
          "& .MuiTypography-root": {
            fontSize: "0.75rem",
            fontWeight: 400,
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 1,
            WebkitBoxOrient: "vertical",
          },
        },
        iconWrapper: {
          width: "auto",
          marginRight: theme.spacing(1),
          "& .MuiSvgIcon-root": {
            height: 16,
            color: "inherit",
          },
        },
      },
    },
    ListPrivilegeItemCard: {
      styleOverrides: {
        root: {
          boxShadow: theme.shadows[1],
          borderRadius: "8px",
          padding: theme.spacing(1),
          display: "flex",
          alignItems: "center",
          gap: theme.spacing(2),
          "& .MuiSvgIcon-root": {
            color: theme.palette.grey[500],
            width: 16,
            height: 16,
          },
        },
        label: {
          color: theme.palette.text.secondary,
          fontWeight: 600,
        },
      },
    },
    FeatureSummary: {
      styleOverrides: {
        root: {},
        container: {
          display: "flex",
          gap: theme.spacing(2),
          boxShadow: "none",
        },
        logoContainer: {
          width: "60px",
          height: "60px",
        },
        infoSection: {},
        infoContainer: {},
        title: {
          marginBottom: theme.spacing(1),
        },
        endAdornment: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          width: "80px",
          height: "80px",
          paddingLeft: theme.spacing(2),
          "&:after": {
            content: "''",
            position: "absolute",
            width: "1px",
            top: 0,
            left: 0,
            bottom: 0,
            backgroundColor: theme.palette.grey[500],
            marginTop: theme.spacing(1.25),
            marginBottom: theme.spacing(1.25),
          },
        },
      },
    },
    MuiTypography: {
      variants: [
        {
          props: { variant: "subtitle1" },
          style: {
            lineHeight: 1.4,
          },
        },
      ],
    },
    DirectionStepItem: {
      styleOverrides: {
        root: {
          "& .MuiStepLabel-iconContainer": {
            paddingRight: theme.spacing(4),
          },
          "&:first-of-type": {
            "& .MuiListItemText-primary": {
              fontWeight: 700,
            },
          },
          "&:last-of-type": {
            "& .MuiListItemText-primary": {
              fontWeight: 600,
            },
            "& .MuiStepLabel-iconContainer": {
              paddingLeft: theme.spacing(0.5),
              paddingRight: theme.spacing(3),
            },
          },

          "& .MuiStepIcon-root": {
            width: 37,
            height: 37,
            "& .MuiStepIcon-text": {
              fontSize: theme.typography.caption.fontSize,
            },
          },
          "& .MuiStepLabel-vertical": {
            padding: 0,
          },
        },
        listItem: {
          "& .MuiListItemText-primary": {
            whiteSpace: "normal",
            color: theme.palette.text.primary,
            fontSize: theme.typography.body2.fontSize,
            fontWeight: theme.typography.subtitle2.fontWeight,
          },
          "& .MuiListItemText-secondary": {
            fontSize: "0.75rem",
          },
          "& .MuiListItemSecondaryAction-root": {
            marginLeft: "auto",
            position: "static",
            transform: "none",
            color: theme.palette.text.secondary,
            right: 0,
          },
        },
      },
    },
    EmptyData: {
      styleOverrides: {
        root: {
          width: "100%",
          alignItems: "center",
          "& .MuiSvgIcon-root": {
            width: "192px",
            height: "192px",
            color: theme.palette.grey[500],
          },
        },
        primaryText: {
          fontSize: "2rem",
          fontWeight: 700,
        },
        secondaryText: {
          color: theme.palette.grey[500],
          fontSize: "1.5rem",
          marginTop: theme.spacing(3),
        },
        iconWrapper: {
          marginBottom: theme.spacing(5),
        },
      },
    },
    NewShopsPage: {
      styleOverrides: {
        filterSection: {
          margin: theme.spacing(0, -3),
        },
        filterContainer: {
          paddingLeft: 0,
          paddingBottom: 3,
        },
        filterButton: {
          whiteSpace: "nowrap",
          gap: theme.spacing(2),
          "& .MuiSvgIcon-root": {
            marginRight: theme.spacing(1),
          },
          ":first-of-type": {
            marginLeft: theme.spacing(3),
          },
        },
        newShopAvatarFallBack: {},
        newShopImageCard: {
          display: "block",
          width: "235px",
          height: "235px",
          "& .MuiCardActionArea-root, & .MuiCardMedia-root": {
            height: "100%",
            width: "100%",
          },
          "& .MuiCardHeader-root": {
            padding: theme.spacing(2),
          },
          "& .MuiCardHeader-root .MuiCardHeader-title": {
            lineHeight: 1.3,
          },
          "& .MuiCardHeader-content": {
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignSelf: "stretch",
          },
          "& .MuiCardHeader-title": {
            overflow: "hidden",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            marginBottom: theme.spacing(0.1875),
            fontWeight: 700,
          },
          "& .MuiCardHeader-subheader": {
            fontWeight: 400,
            "& .sub-category-text": {
              overflow: "hidden",
              fontSize: "0.75rem",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              maxWidth: "90%",
              display: "none",
            },
            "& .booth-name-text": {
              overflow: "hidden",
              fontSize: "0.75rem",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              maxWidth: "90%",
              display: "none",
            },
          },
          "&.no-image": {
            "& .MuiCardActionArea-root:after": {},
          },
          "& .MuiChip-root": {
            backgroundColor: theme.palette.error.main,
            color: theme.palette.error.contrastText,
          },
          "& .MuiCardHeader-root .MuiCardHeader-avatar": {
            marginRight: theme.spacing(2),
          },
          "& .MuiCardHeader-avatar .MuiAvatar-root": {
            width: "64px",
            height: "64px",
            "& .MuiSvgIcon-root": {
              width: "32px",
              height: "32px",
            },
          },
        },
        newShopFallbackImageIconWrapper: {
          display: "flex",
          justifyContent: "center",
          alignItems: "start",
          color: theme.palette.common.white,
          height: "100%",
          width: "100%",
          background: theme.palette.grey[500],
          paddingTop: "30%",
        },
        newShopFallbackImageIcon: {
          height: "64px",
          width: "64px",
          zIndex: 1,
        },
        comingSoonShopAvatarFallBack: {},
        comingSoonShopImageCard: {
          display: "block",
          width: "235px",
          height: "235px",
          "& .MuiCardActionArea-root, & .MuiCardMedia-root": {
            height: "100%",
            width: "100%",
          },
          "& .MuiCardHeader-root": {
            padding: theme.spacing(2),
          },
          "& .MuiCardHeader-root .MuiCardHeader-title": {
            lineHeight: 1.3,
          },
          "& .MuiCardHeader-content": {
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignSelf: "stretch",
          },
          "& .MuiCardHeader-title": {
            overflow: "hidden",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            marginBottom: theme.spacing(0.1875),
            fontWeight: 700,
          },
          "& .MuiCardHeader-subheader": {
            fontWeight: 400,
            "& .sub-category-text": {
              overflow: "hidden",
              fontSize: "0.75rem",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              maxWidth: "90%",
              display: "none",
            },
            "& .booth-name-text": {
              overflow: "hidden",
              fontSize: "0.75rem",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              maxWidth: "90%",
              display: "none",
            },
          },
          "& .MuiCardActionArea-root:after": {
            background:
              "linear-gradient(180deg, rgba(255, 255, 255, 0.5) -50%, rgba(0, 0, 0, 0.90) 100%)",
          },
          "&.no-image": {
            "& .MuiCardActionArea-root:after": {
              background: "linear-gradient(180deg, #FFF -41.34%, #000 99.92%)",
            },
          },
          "& .MuiCardHeader-avatar .MuiAvatar-root": {
            width: "64px",
            height: "64px",
            "& .MuiSvgIcon-root": {
              width: "32px",
              height: "32px",
            },
          },
          "& .MuiChip-root": {
            backgroundColor: theme.palette.grey[300],
            color: theme.palette.grey[500],
          },
        },
        comingSoonShopFallbackImageIconWrapper: {
          display: "flex",
          justifyContent: "center",
          alignItems: "start",
          color: theme.palette.grey[400],
          height: "100%",
          width: "100%",
          background: theme.palette.grey[500],
          paddingTop: "30%",
        },
        comingSoonShopFallbackImageIcon: {
          height: "64px",
          width: "64px",
          zIndex: 1,
        },
        venueSelector: {
          position: "fixed",
          bottom: "175px",
          right: "690px",
          zIndex: 2,
        },
        contentWrapper: {
          height: "100%",
        },
        emptyDataWrapper: {
          position: "absolute",
          left: "50%",
          top: "50%",
          transform: "translate(-50%, -50%)",
          width: "370px",
        },
        gridContainer: {
          position: "relative",
          display: "grid",
          gridAutoFlow: "dense",
          gridAutoRows: "max-content",
          gridTemplateColumns: "repeat(auto-fill, minmax(235px, 1fr))",
          gap: theme.spacing(3),
          paddingBottom: theme.spacing(8.75),
          overflowY: "auto",
          height: "100%",
          //hide scrollbar
          "::-webkit-scrollbar": {
            display: "none",
          },
          MsOverflowStyle: "none",
          scrollbarWidth: "none",
          "&.emptyList": {},
        },
        gridItem: {
          height: "230px",
        },
        pageCard: {
          "&:after": {
            content: "''",
            pointerEvents: "none",
            display: "inline-block",
            position: "absolute",
            zIndex: 1,
            left: 0,
            right: 0,
            bottom: 0,
            minHeight: "180px",
            background:
              "linear-gradient(0deg, #FFF 2.8%, rgba(255, 255, 255, 0.00) 50%)",
          },
        },
      },
    },
    OccupantCard: {
      styleOverrides: {
        root: {
          boxShadow: theme.shadows[1],
          borderRadius: "10px",
          width: "100%",
        },
        cardTitle: {
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          color: theme.palette.text.primary,
          wordBreak: "break-word",
        },
        cardMediaWrapper: {
          position: "relative",
        },
        cardMedia: {
          height: "180px",
        },
        cardContent: {
          padding: theme.spacing(1.5, 2),
          "&:last-child": {
            paddingBottom: theme.spacing(1),
          },
        },
      },
    },
    UserLocationListItem: {
      styleOverrides: {
        icon: {
          background: "transparent",
          color: theme.palette.text.primary,
          fontSize: "3rem",
          "& .MuiSvgIcon-root": {
            fontSize: "inherit",
          },
        },
      },
    },
    FeatureListItem: {
      defaultProps: {
        boothNameTextSeparator: " | ",
        locationTextSeparator: " | ",
      },
      styleOverrides: {
        root: {
          display: "flex",
          flexDirection: "row",
          paddingLeft: theme.spacing(2),
          paddingRight: theme.spacing(2),
        },
        adornmentWrapper: {
          display: "none",
          flexDirection: "row",
          height: "55px",
        },
        adornmentMedia: {
          objectFit: "contain",
          maxWidth: "60px",
          maxHeight: "55px",
        },
        adornmentDivider: {
          marginLeft: theme.spacing(3),
          marginRight: theme.spacing(2),
          borderRight: "1px solid rgba(203, 203, 203, 0.5)",
        },
        adornmentTextAvatar: {
          width: 32,
          height: 32,
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.primary.contrastText,
          minWidth: 32,
          borderRadius: "50%",
          display: "none",
          justifyContent: "center",
          alignItems: "center",
          fontSize: "0.75rem",
        },
        bottomDivider: {
          borderBottom: "1px solid rgba(203, 203, 203, 0.5)",
          marginLeft: theme.spacing(2),
          marginRight: theme.spacing(2),
        },
        listItemText: {
          "& .MuiListItemText-primary": {
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            lineHeight: 1.4,
            wordBreak: "break-all",
          },
          "& .MuiListItemText-secondary": {
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 1,
            WebkitBoxOrient: "vertical",
            lineHeight: 1.4,
          },
        },
        listItemAvatar: {
          "& .MuiAvatar-root": {
            fontSize: "2.275rem",
          },
          "& .MuiSvgIcon-root": {
            fontSize: "inherit",
          },
        },
        boothNameText: {
          display: "none",
        },
        venueText: {
          display: "none",
        },
        categoryText: {
          display: "none",
        },
        sponsoredChip: {
          display: "none",
        },
      },
    },
    DirectionSearchContainer: {
      styleOverrides: {
        wrapper: {
          width: "100%",
          [theme.breakpoints.down("sm")]: {
            maxWidth: "100%",
          },
        },
        suggestionList: {
          marginTop: theme.spacing(8),
          // direction search box = 108 px
          // avoid step button 32 px + top-bottom margin 16px * 2 = 64px
          // top-bottom page layout padding 24px * 2 = 48px
          maxHeight: `calc(100vh - 220px)`,
          overflow: "auto",
          background: theme.palette.background.paper,
          boxShadow: theme.shadows[1],
          position: "absolute",
          zIndex: theme.zIndex.drawer + 1,
          borderRadius: "10px",
          //left-right layout padding = 24 * 2 = 48px
          width: `calc(100vw - 48px)`,
          [theme.breakpoints.up("sm")]: {
            //left-right layout padding = 24 * 2 = 48px
            maxWidth: mixins.mobileDirectionSearch.width - 48,
          },
        },
      },
    },
    AppOrdinalSelector: {
      styleOverrides: {
        root: {
          width: "80px",
          borderRadius: "16px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          background: theme.palette.background.paper,
          boxShadow:
            "0 50px 14px 0 rgba(0, 0, 0, 0.00), 0 32px 13px 0 rgba(0, 0, 0, 0.01), 0 18px 11px 0 rgba(0, 0, 0, 0.05), 0 8px 8px 0 rgba(0, 0, 0, 0.09), 0 2px 4px 0 rgba(0, 0, 0, 0.10)",
        },
        ordinalList: {
          padding: theme.spacing(1),
          gap: theme.spacing(0.5),
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          overflowY: "auto",
          "&::-webkit-scrollbar": {
            display: "none",
          },
        },
        listItemButton: {
          width: 72,
          height: 72,
          justifyContent: "center",
          borderRadius: "12px",
          backgroundColor: theme.palette.background.paper,
          fontSize: "1.25rem",
          transition: `color ${theme.transitions.duration.short}ms ${theme.transitions.duration.short}ms ${theme.transitions.easing.easeInOut} , background - color ${theme.transitions.duration.short}ms ${theme.transitions.easing.easeInOut} `,
          fontWeight: theme.typography.fontWeightBold,
          color: theme.palette.text.primary,
          padding: theme.spacing(2),
          ":hover": {
            backgroundColor: theme.palette.primary.main,
          },
          "&.Mui-selected": {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main,
            opacity: 1,
            "&:hover": {
              backgroundColor: theme.palette.primary.main,
            },
          },
        },
        ordinalSelectorTitle: {
          display: "none",
        },
      },
    },
    AppPageCard: {
      styleOverrides: {
        root: {
          borderRadius: "16px",
          height: "100%",
          boxShadow: "none",
        },
      },
    },
    AppPageCardContent: {
      styleOverrides: {
        root: {
          height: "100%",
          padding: theme.spacing(3, 4),
        },
      },
    },
    LanguageButton: {
      defaultProps: {
        MenuProps: {
          transformOrigin: { horizontal: "center", vertical: "bottom" },
          anchorOrigin: { horizontal: "center", vertical: "top" },
        },
      },
      styleOverrides: {
        root: {
          "&:hover": {
            boxShadow: "none",
          },
        },
        menuPaper: {
          overflow: "visible",
          filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
          "& .MuiAvatar-root": {
            width: 32,
            height: 32,
            marginLeft: theme.spacing(-0.5),
            marginRight: theme.spacing(1),
          },
          "&:before": {
            content: '""',
            display: "block",
            position: "absolute",
            bottom: 0,
            left: `50 % `,
            width: `10px`,
            height: `10px`,
            backgroundColor: theme.palette.background.paper,
            transform: "translate(-50%, 50%) rotate(45deg)",
            zIndex: 0,
          },
        },
        label: {},
        avatar: {
          width: "24px",
          height: "24px",
          padding: "2px",
          boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.10)",
          "&> img": {
            borderRadius: 9999,
          },
        },
        secondaryLabel: { display: "none" },
        labelContainer: {},
      },
    },
    AppQRCode: {
      styleOverrides: {
        root: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "transparent",
          boxShadow: "none",
          position: "relative",
          padding: theme.spacing(0.5),
          width: 80,
          height: 80,
          "&:before,:after, .MuiCardContent-root:before, .MuiCardContent-root:after":
            {
              display: "block",
              content: '""',
              width: "20px",
              height: "20px",
              position: "absolute",
            },
          "&:before": {
            top: 0,
            left: 0,
            borderTop: `3px solid ${theme.palette.common.black} `,
            borderLeft: `3px solid ${theme.palette.common.black} `,
            borderRadius: "3px",
          },
          "&:after": {
            bottom: 0,
            left: 0,
            borderBottom: `3px solid ${theme.palette.common.black} `,
            borderLeft: `3px solid ${theme.palette.common.black} `,
            borderRadius: "3px",
          },
          "& .MuiCardContent-root:before": {
            top: 0,
            right: 0,
            borderTop: `3px solid ${theme.palette.common.black} `,
            borderRight: `3px solid ${theme.palette.common.black} `,
            borderRadius: "3px",
          },
          "& .MuiCardContent-root:after": {
            bottom: 0,
            right: 0,
            borderBottom: `3px solid ${theme.palette.common.black} `,
            borderRight: `3px solid ${theme.palette.common.black} `,
            borderRadius: "3px",
          },
          "& .MuiCardContent-root": {
            border: "none",
            height: 80,
            width: 80,
            "&:last-child": {
              paddingBottom: theme.spacing(0.5),
            },
          },
        },
        qrCodeContent: {
          display: "flex",
          borderRadius: "8px",
          border: `5px solid ${theme.palette.primary.main} `,
          padding: theme.spacing(0.5),
        },
        qrCodeCaption: {
          fontSize: "1rem",
          paddingTop: theme.spacing(1.5),
        },
        qrCodeSecondaryCaption: {
          lineHeight: 1,
        },
        qrCode: {
          width: "100%",
          height: "100%",
          border: "4px solid #fff",
        },
      },
    },
    AppDetailPage: {
      defaultProps: {
        locationTextKeys: ["floorText"],
        locationSeparator: " | ",
        locationEmpty: "-",
        promotionCarouselOption: {
          limitPaginations: 7,
        },
      },
      styleOverrides: {
        root: {
          display: "flex",
          flexDirection: "column",
          height: "100%",
        },
        avatarRoot: {
          margin: 0,
          width: "80px",
          height: "80px",
          borderRadius: "8px",
          fontSize: "3rem",
          boxShadow: `0px 8px 24px 0px rgba(155, 155, 155, 0.15)`,
          "& .MuiAvatar-img": {
            objectFit: "cover",
          },
        },
        titleText: {
          fontWeight: 700,
        },
        captionText: {
          color: theme.palette.text.secondary,
          fontWeight: 700,
        },
        contentContainer: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: theme.spacing(0, 3.75),
          flexGrow: 1,
          gap: theme.spacing(1),
        },
        headerContainer: {
          display: "flex",
          flexDirection: "column",
          paddingTop: theme.spacing(4),
          gap: theme.spacing(1.5),
          alignItems: "center",
        },
        titleContainer: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: theme.spacing(1),
        },
        tabsContainer: {
          width: "364px",
          display: "flex",
          justifyContent: "center",
        },
        placeDetailTabs: {
          width: "100%",
          "&.MuiTabs-root": {
            minHeight: "35px",
          },
        },
        placeDetailTab: {
          flex: 1,
          "&.MuiButtonBase-root": {
            minHeight: "35px",
            padding: theme.spacing(0),
            fontSize: "1rem",
          },
          color: theme.palette.grey[600],
          "&.Mui-selected": {
            color: theme.palette.primary,
          },
          "&.Mui-disabled": {
            color: theme.palette.grey[300],
          },
        },
        descriptionText: {
          height: 100,
          color: theme.palette.text.secondary,
          overflowY: "auto",
          fontSize: "0.875rem",
          lineHeight: 1.5,
          width: "100%",
          marginBottom: theme.spacing(1),
          "&::-webkit-scrollbar": {
            width: "8px",
          },
          "::-webkit-scrollbar-track": {
            borderRadius: "8px",
            background: theme.palette.grey[300],
          },
          "::-webkit-scrollbar-thumb": {
            borderRadius: "8px",
            background: theme.palette.primary.main,
          },
          "::-webkit-scrollbar-thumb:hover": {
            background: theme.palette.primary.main,
          },
        },
        locationContainer: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: theme.spacing(2),
          height: "139px",
        },
        locationDetail: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(2),
          "& .MuiListItem-root": {
            padding: 0,
          },
          "& .MuiListItemText-root": {
            gap: theme.spacing(1),
            display: "flex",
            flexDirection: "column",
            textTransform: "uppercase",
            margin: 0,
          },
          "& .MuiListItemText-primary": {
            color: theme.palette.text.secondary,
            fontWeight: 400,
            fontSize: "1rem",
          },
          "& .MuiListItemText-secondary": {
            color: theme.palette.text.primary,
            fontWeight: 700,
            fontSize: "1.125rem",
          },
        },
        buildingLogo: {
          height: "50px",
          marginLeft: theme.spacing(5),
          "& img": {
            width: "100%",
            height: "100%",
          },
        },
        actionContainer: {
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          marginTop: "auto",
          width: "100%",
        },
        stretchButton: {
          height: "43px",
          width: "100%",
          textTransform: "capitalize",
        },
        locationDetailIcon: {
          color: theme.palette.secondary.main,
        },
        locationDetailContainer: {
          display: "flex",
          alignItems: "center",
          gap: theme.spacing(1),
        },
        locationTextContainer: {},
        categoryTextContainer: {},
        locationText: {
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          wordBreak: "break-all",
        },
        qrCodeContainer: {
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: theme.spacing(1),
        },
        qrcodeText: {
          textTransform: "uppercase",
          fontSize: "0.625rem",
        },
        galleryCarouselImage: {
          width: "100%",
          height: "192px",
          objectFit: "cover",
          borderRadius: "10px",
        },
        galleryCarouselItem: {},
        galleryCarousel: {
          "& .splide__track": {
            margin: 0,
            padding: 0,
            borderRadius: "10px",
          },
          "& .splide__pagination__page": {
            marginTop: theme.spacing(1.5),
            width: "8px",
            height: "8px",
          },
          "& .splide__pagination__page.is-active": {
            backgroundColor: theme.palette.secondary.main,
            transition: `width ${theme.transitions.duration.short}ms ${theme.transitions.easing.easeInOut}, borderRadius ${theme.transitions.duration.standard}s ${theme.transitions.easing.easeInOut} `,
            transform: "none",
            width: "47.25px",
            borderRadius: "35px",
          },
        },
        galleryCarouselWrapper: {
          width: "100%", //Prevent unexpected slide displays in SplideJS.
        },
        promotionCarouselWrapper: {
          width: "100%",
          marginBottom: theme.spacing(-1),
        },
        promotionCarousel: {
          "& .splide__slide": {
            padding: theme.spacing(0.5),
          },
          "& .splide__track": {
            margin: theme.spacing(0),
            padding: theme.spacing(0),
          },
          "& .splide__pagination__page": {
            marginTop: theme.spacing(1.5),
            width: "8px",
            height: "8px",
          },
          "& .splide__pagination__page.is-active": {
            backgroundColor: theme.palette.secondary.main,
            transition: `width ${theme.transitions.duration.short}ms ${theme.transitions.easing.easeInOut}, borderRadius ${theme.transitions.duration.standard}s ${theme.transitions.easing.easeInOut} `,
            transform: "none",
            width: "47.25px",
            borderRadius: "35px",
          },
        },
        promotionCarouselItem: {},
        promotionCard: {
          minHeight: "370px",
          width: "100%",
          "& .MuiCardMedia-root": {
            maxHeight: "340px",
            height: "370px",
          },
          "& .PromotionCard-cardContent": {
            flex: 1,
          },
        },
        sidebarContent: {},
      },
    },
    OrdinalSelectMenu: {
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.background.paper,
          height: "56px",
          width: "171px",
          textAlign: "center",
          borderRadius: "9999px",
          boxShadow: "0px 4px 14px 0px rgba(0, 0, 0, 0.20)",
          "&.Mui-focused": {
            border: "none",
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            "& svg": {
              color: theme.palette.primary.contrastText,
            },
          },
          "& .MuiSelect-select.MuiInputBase-input": {
            paddingTop: theme.spacing(1.75),
            paddingBottom: theme.spacing(1.75),
            paddingLeft: theme.spacing(2.5),
            fontSize: "1.5rem",
            minHeight: "unset",
          },
        },
        paper: {
          backgroundColor: "transparent",
          boxShadow: "none",
          alignItems: "center",
          maxHeight: "35vh",
          //hide scrollbar
          "::-webkit-scrollbar": {
            display: "none",
          },
          MsOverflowStyle: "none",
          scrollbarWidth: "none",
        },
        menuList: {
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
        },
        menuItem: {
          margin: theme.spacing(1),
          backgroundColor: theme.palette.background.paper,
          borderRadius: "50%",
          height: "48px",
          width: "48px",
          padding: 0,
          minHeight: "40px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          transformOrigin: "top center",
          animation: `slideUp 300ms ease -in -out forwards`,
          "&.Mui-selected": {
            backgroundColor: theme.palette.primary.main,
            border: `1px solid ${theme.palette.primary.contrastText} `,
            color: theme.palette.primary.contrastText,
            ":hover": {
              backgroundColor: theme.palette.primary.main,
            },
          },
          ":hover": {
            backgroundColor: theme.palette.primary.main,
          },
        },
        text: {
          fontSize: "1.25rem",
          textTransform: "uppercase",
          letterSpacing: "1px",
          color: theme.palette.text.secondary,
        },
      },
    },
    VenueSelector: {
      styleOverrides: {
        root: {
          gap: theme.spacing(3),
        },
        buttonWrapper: {
          display: "flex",
          justifyContent: "center",
          transition: `transform ${theme.transitions.duration.shortest}ms ${theme.transitions.easing.easeIn} `,
          "&.selected": {
            transform: "scale(1.77)",
            marginLeft: theme.spacing(3),
            marginRight: theme.spacing(3),
          },
        },
        button: {
          width: 70,
          height: 70,
          padding: 0,
          backgroundColor: theme.palette.primary.main,
          borderRadius: "50%",
          "&.Mui-selected": {
            backgroundColor: theme.palette.primary.main,
            ":hover": {
              backgroundColor: theme.palette.primary.main,
            },
          },
        },
        allVenueIcon: {
          width: "100%",
          height: "100%",
        },
        icon: {
          width: "100%",
          height: "100%",
        },
        currentVenueChip: {
          width: "48px",
          height: "12px",
          position: "absolute",
          bottom: "-4px",
        },
        allVenueLabel: {
          display: "none",
        },
      },
    },
    SwitchVenueStep: {
      styleOverrides: {
        root: {
          gap: theme.spacing(5),
          flexDirection: "row",
          alignItems: "center",
        },
        venueLogo: { height: "65px", width: "143px", objectFit: "contain" },
        iconContainer: {
          height: "100%",
          display: "flex",
          alignItems: "center",
          "& .MuiSvgIcon-root": {
            width: "40px",
            height: "40px",
            "& .primary": {
              fill: theme.palette.primary.main,
            },
          },
        },
      },
    },
    BorderLinearProgress: {
      styleOverrides: {
        root: {
          position: "relative",
          width: "100%",
          "&:after": {
            position: "absolute",
            top: "50%",
            transform: "translateY(-50%)",
            content: "''",
            display: "block",
            height: 4,
            width: "100%",
            borderRadius: 5,
            backgroundColor: theme.palette.grey[300],
            right: 0,
          },
        },
        linearProgress: {
          height: 20,
          borderRadius: 15,
          zIndex: 1,
          ":after": {
            position: "absolute",
            zIndex: 5,
            top: "50%",
            transform: "translateY(-50%)",
            height: 4,
            content: "''",
            display: "block",
          },
          "&.MuiLinearProgress-colorPrimary": {
            backgroundColor: "transparent",
            "&.Mui-start": {
              ":after": {
                backgroundColor: theme.palette.primary.main,
              },
            },
            ":after": {
              position: "absolute",
              top: "50%",
              transform: "translateY(-50%)",
              content: "''",
              display: "inline-block",
              width: 14,
              height: 14,
              borderRadius: "50%",
              backgroundColor: theme.palette.grey[300],
              zIndex: 1,
              left: 0,
            },
            "&.Mui-complete": {
              ":before": {
                backgroundColor: theme.palette.primary.main,
              },
              ":after": {
                backgroundColor: theme.palette.primary.main,
              },
            },
            ":before": {
              position: "absolute",
              top: "50%",
              transform: "translateY(-50%)",
              content: "''",
              display: "inline-block",
              width: 14,
              height: 14,
              borderRadius: "50%",
              backgroundColor: theme.palette.grey[300],
              zIndex: 1,
              right: 0,
            },
          },
          "& .MuiLinearProgress-bar": {
            margin: "auto 0",
            height: 4,
            borderRadius: 5,
            backgroundColor: theme.palette.primary.main,
            boxShadow: `0px 0px 10px ${theme.palette.primary.main} `,
          },
        },
      },
    },
    VerticalLinearProgress: {
      styleOverrides: {
        root: {
          height: "186px",
          margin: theme.spacing(1.25, 0),
        },
        slider: {
          color: theme.palette.primary.main,
          width: "3px",
          borderRadius: 0,
          "& .MuiSlider-thumb": {
            width: "21px",
            height: "21px",
            transition: `bottom ${theme.transitions.duration.complex}ms ${theme.transitions.easing.easeInOut} `,
            "&.Mui-focusVisible": {
              boxShadow: "none",
            },
          },
          "& .MuiSlider-rail": {
            color: theme.palette.grey[300],
            opacity: 1,
          },
          "& .MuiSlider-track": {
            boxShadow: `0px 0px 10px ${theme.palette.primary.main} `,
            borderWidth: 0,
            transition: `height ${theme.transitions.duration.complex}ms ${theme.transitions.easing.easeInOut} `,
          },
          '& input[type="range"]': {
            WebkitAppearance: "slider-vertical",
          },
        },
      },
    },
    CategoryQuickSearch: {
      styleOverrides: {
        categoryFilterBarContainer: {
          position: "relative",
          order: 1,
        },
        scrollPane: {
          padding: 0,
        },
        categoryFilterBar: {
          "& .MuiSvgIcon-root": {
            width: "24px",
            height: "24px",
            display: "none",
          },
          "& .highlight .MuiSvgIcon-root": {
            display: "block",
          },
        },
        categoryFilterChip: {
          "& .CategoryFilterChip-icon": {
            display: "none",
          },
        },
      },
    },
    MapUpdateLoadingScreen: {
      styleOverrides: {
        backdrop: {
          zIndex: theme.zIndex.modal,
        },
        container: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: theme.spacing(1),
          color: theme.palette.primary.main,
        },
      },
    },
    StepByStepIcon: {
      defaultProps: {
        waveColor: theme.palette.primary.main,
      },
      styleOverrides: {},
    },
    VerticalStepProgressBar: {
      styleOverrides: {
        wrapper: {
          height: "100%",
          padding: theme.spacing(1),
          marginTop: 0,
        },
        stepperContainer: {
          height: "100%",
          overflowY: "scroll",
          scrollbarWidth: "none", // Hide the scrollbar for firefox
          scrollbarHeight: "none", // Hide the scrollbar for firefox
          "&::-webkit-scrollbar": {
            display: "none", // Hide the scrollbar for WebKit browsers (Chrome, Safari, Edge, etc.)
          },
          "&-ms-overflow-style:": {
            display: "none", // Hide the scrollbar for IE
          },
        },
        stepper: {
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          zIndex: 1,
          "& .MuiStepLabel-label": {
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 3,
            WebkitBoxOrient: "vertical",
            whiteSpace: "normal",
            position: "relative",
            bottom: theme.spacing(-5),
          },
          "& .MuiStepLabel-iconContainer": {
            paddingRight: theme.spacing(1),
            "&:last-child": {
              paddingRight: 0,
            },
          },
          "& .step": {
            width: "28px",
            height: "28px",
          },
          "&.originStep": {
            visibility: "hidden",
          },
          "& .StepByStepIcon-destination": {
            visibility: "hidden",
            width: "28px",
            height: "28px",
          },
        },
        originIcon: {
          "&.MuiSvgIcon-root": {
            height: "28px",
            width: "28px",
            fill: theme.palette.primary.main,
          },
        },
        connector: {
          marginLeft: theme.spacing(1.25),
          "& .MuiStepConnector-line": {
            width: "8px",
            border: 0,
            minHeight: "86px",
            margin: theme.spacing(-2.5, 0),
            backgroundColor: theme.palette.grey[200],
            borderRadius: 1,
            height: "calc(100% + 30px)",
          },
          "&.Mui-active": {
            "& .MuiStepConnector-line": {
              backgroundColor: theme.palette.primary.main,
            },
          },
          "&.Mui-completed": {
            "& .MuiStepConnector-line": {
              backgroundColor: theme.palette.primary.main,
            },
          },
          "&.MuiStepConnector-vertical": {},
        },
      },
    },
    VuiNotificationContainer: {
      styleOverrides: {
        root: {},
        snackbarContent: {
          marginTop: `${mixins.hKioskHeader?.height || 100}px`,
          marginRight: "calc(32vw - 8px)", //aside width,
        },
      },
    },
    SuggestionListItem: {
      defaultProps: {},
    },
    LanguageButtonMenu: {
      styleOverrides: {
        wrapper: {
          height: 48,
          display: "flex",
          flexDirection: "row",
          width: "100%",
          padding: theme.spacing(0, 4),
          gap: theme.spacing(3),
        },
        button: {
          borderRadius: "8px",
          border: `1px solid ${theme.palette.primary.main} `,
          flexDirection: "row",
          gap: theme.spacing(1),
          width: 162,
          color: theme.palette.primary.main,
          "& .MuiBottomNavigationAction-label": {
            textTransform: "capitalize",
            fontWeight: 700,
            "&.Mui-selected": {
              fontSize: "1rem",
            },
          },
          "&.Mui-selected": {
            "&:last-of-type": {
              borderTopRightRadius: "8px",
              borderBottomRightRadius: "8px",
            },
            "&:first-of-type": {
              borderTopLeftRadius: "8px",
              borderBottomLeftRadius: "8px",
            },
          },
        },
        avatar: {
          width: "24px",
          height: "24px",
          boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.10)",
          "&> img": {
            borderRadius: 9999,
          },
        },
      },
    },
    SkeletonPromotionDetail: {
      styleOverrides: {
        titleText: {
          fontSize: "1.25rem",
        },
        descriptionText: {
          height: "320px",
          margin: theme.spacing(1.5, 4, 0),
        },
        detailContainer: {
          padding: theme.spacing(5, 4, 3),
          height: "100%",
          display: "flex",
          flexDirection: "column",
        },
        locationButton: {
          marginTop: theme.spacing(3),
          width: "100%",
          height: 43,
        },
        qrCode: {
          height: 80,
          width: 80,
        },
        infoListItem: {
          width: 216,
          height: 40,
        },
        locationButtonContainer: {
          flexGrow: 1,
          display: "flex",
          flexDirection: "column-reverse",
        },
        listItemContainer: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(1),
          padding: theme.spacing(1),
          width: "216px",
        },
        infoContainer: {
          marginTop: theme.spacing(3),
          display: "flex",
          flexDirection: "row",
          gap: theme.spacing(3),
          padding: theme.spacing(3),
        },
        qrcodeText: {
          marginTop: theme.spacing(1),
          fontSize: "0.75rem",
        },
      },
    },
    SkeletonEventDetailSidebar: {
      styleOverrides: {
        titleText: {
          fontSize: "1.25rem",
        },
        descriptionText: {
          height: "280px",
          margin: theme.spacing(1.5, 4, 0),
        },
        detailContainer: {
          padding: theme.spacing(5, 4, 3),
          height: "100%",
          display: "flex",
          flexDirection: "column",
        },
        locationButton: {
          marginTop: theme.spacing(2),
          width: "100%",
          height: 43,
        },
        qrCode: {
          height: 80,
          width: 80,
        },
        infoListItem: {
          width: 216,
          height: 40,
        },
        locationButtonContainer: {
          flexGrow: 1,
          display: "flex",
          flexDirection: "column-reverse",
        },
        listItemContainer: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(1),
          padding: theme.spacing(1),
        },
        infoContainer: {
          display: "flex",
          flexDirection: "row",
          gap: theme.spacing(3),
          padding: theme.spacing(2, 3),
        },
        qrcodeText: {
          marginTop: theme.spacing(1),
          fontSize: "0.75rem",
        },
        gallery: {
          width: "100%",
          height: "170px",
          order: 2,
        },
      },
    },
    AppImageCarouselModal: {
      styleOverrides: {
        root: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: theme.spacing(2),
          top: 0,
          bottom: 0,
        },
        carouselContainer: {
          position: "relative",
          outline: "none",
          width: "100%",
        },
        closeButton: {
          color: theme.palette.common.white,
          position: "absolute",
          top: theme.spacing(-11.25),
          right: theme.spacing(6),
          width: "40px",
          height: "40px",
          backgroundColor: alpha(theme.palette.common.black, 0.32),
          "& .MuiSvgIcon-root": {
            width: "16px",
            height: "16px",
          },
        },
        carousel: {
          "& .splide": {
            margin: "0 auto",
          },
          "& .splide__pagination": {
            marginTop: theme.spacing(7.25),
          },
          "& .splide__pagination__page": {
            width: "14px",
            height: "14px",
          },
          "& .splide__pagination__page.is-active": {
            transition: `width ${theme.transitions.duration.short}ms ${theme.transitions.easing.easeInOut}, borderRadius ${theme.transitions.duration.standard}s ${theme.transitions.easing.easeInOut} `,
            transform: "none",
            width: 45,
            borderRadius: 30,
          },
          "& .splide__track": {
            padding: 0,
          },
          "& .splide__arrow--prev": {
            left: "unset",
            "& svg": {
              transform: "unset",
            },
          },
          "& .splide__arrow--next": {
            right: "unset",
          },
        },
        carouselItem: {
          maxWidth: "900px",
        },
        image: {
          margin: "0 auto",
          width: "876px",
          height: "480px",
          borderRadius: "10px",
        },
        carouselArrows: {
          display: "flex",
          flexDirection: "row",
          gap: theme.spacing(3),
          position: "absolute",
          right: theme.spacing(6),
          bottom: theme.spacing(-1),
        },
        prevButton: {
          color: theme.palette.common.white,
          width: "40px",
          height: "40px",
          backgroundColor: alpha(theme.palette.common.black, 0.32),
          "& .MuiSvgIcon-root": {
            width: "16px",
            height: "16px",
          },
          "&:hover": {
            backgroundColor: alpha(theme.palette.common.black, 0.32),
          },
        },
        nextButton: {
          color: theme.palette.common.white,
          width: "40px",
          height: "40px",
          backgroundColor: alpha(theme.palette.common.black, 0.32),
          "& .MuiSvgIcon-root": {
            width: "16px",
            height: "16px",
          },
          "&:hover": {
            backgroundColor: alpha(theme.palette.common.black, 0.32),
          },
        },
        backdrop: {
          top: 0,
          bottom: 0,
        },
      },
    },
    MyLocationButton: {
      styleOverrides: {
        root: {
          height: 80,
          width: 80,
          backgroundColor: theme.palette.background.paper,
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: "16px",
          boxShadow:
            "0px 2px 4px 0px rgba(0, 0, 0, 0.1),0px 8px 8px 0px rgba(0, 0, 0, 0.09),0px 18px 11px 0px rgba(0, 0, 0, 0.05),0px 32px 13px 0px rgba(0, 0, 0, 0.01),0px 50px 14px 0px rgba(0, 0, 0, 0)",
          "&:hover": {
            backgroundColor: theme.palette.background.paper,
          },
        },
        icon: {
          height: 48,
          width: 48,
          color: theme.palette.text.secondary,
        },
      },
    },
    CarouselNavigation: {
      defaultProps: {
        carouselOption: {},
      },
      styleOverrides: {
        root: {
          display: "flex",
          justifyContent: "center",
        },
        carousel: {
          "& .splide__track": {
            margin: 0,
            padding: 0,
          },
        },
        carouselItem: {
          carouselItem: {
            "&.is-active": {
              zIndex: 1,
            },
            "&:not(.is-visible)": {},
            "&.is-move": {},
          },
        },
      },
    },
    CarouselNavigationMenu: {
      styleOverrides: {
        root: {},
      },
    },
    ErrorDialog: {
      styleOverrides: {
        root: {},
        paper: {},
        title: {},
        content: {},
        contentText: {},
        buttonContainer: {},
        button: {},
      },
    },
    CoolDownProgress: {
      styleOverrides: {
        root: {},
        linearProgress: {
          "& .MuiLinearProgress-bar": {
            transition: "transform .1s linear",
          },
        },
      },
    },
    FeatureToggleChipTabBar: {
      styleOverrides: {
        root: {
          "&>.MuiTabs-flexContainer": {
            display: "flex",
            flexDirection: "row",
            gap: theme.spacing(1.25),
          },
        },
        tab: {
          display: "flex",
          flexDirection: "row",
          padding: theme.spacing(1.5, 3),
          borderRadius: "16px",
          boxShadow: "none",
          background: theme.palette.common.white,
          border: `1px solid ${theme.palette.grey[200]}`,
          whiteSpace: "nowrap",
          height: "48px",
          gap: theme.spacing(2),
          minHeight: "48px",
          color: theme.palette.text.primary,
          fontWeight: 400,
          fontSize: "1rem",
          letterSpacing: "0.00938em",
          "&.Mui-selected": {
            background: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            "&>.MuiSvgIcon-root": {
              fill: theme.palette.primary.contrastText,
            },
          },
          "&>.MuiSvgIcon-root": {
            width: "24px",
            height: "24px",
            fill: theme.palette.primary.main,
            marginLeft: theme.spacing(0.5),
            marginRight: "-6px",
          },
          ":hover:not(.Mui-selected)": {
            background: theme.palette.primary.light,
          },
        },
        fallbackTab: { display: "none" },
      },
    },
    SidebarMenu: {
      styleOverrides: {
        root: {
          height: "100%",
          maxHeight: "1000px",
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(2.5),
          transition: `width ${theme.transitions.duration.short}ms ${theme.transitions.easing.easeInOut} ${theme.transitions.duration.shortest}ms`,
        },
        headerContainer: {
          padding: theme.spacing(3),
          justifyContent: "center",
        },
        headerLogo: {},
        navigationContainer: {
          flex: 1,
          maxHeight: "790px",
        },
        toolbarContainer: {
          display: "flex",
          padding: theme.spacing(1.5, 2),
          gap: theme.spacing(2),
        },
        languageButton: {
          display: "none",
        },
        searchButton: {
          width: "260px",
          maxwidth: "260px",
          borderRadius: "16px",
          border: `1px solid ${theme.palette.divider}`,
        },
        languageSelectMenu: {
          height: "100%",
          width: "95px",
          borderRadius: "16px",
        },
      },
    },
    LanguageSelectMenu: {
      defaultProps: {
        MenuProps: {
          anchorOrigin: { horizontal: "center", vertical: "top" },
          transformOrigin: { horizontal: "center", vertical: "bottom" },
        },
      },
      styleOverrides: {
        root: {
          "& .MuiSelect-select.MuiInputBase-input": {
            color: theme.palette.text.secondary,
            fontSize: "1.25rem",
            padding: theme.spacing(2, 4, 1.5, 3),
          },
        },
        menuItem: {
          fontSize: "1.125rem",
        },
      },
    },
    ServicePage: {
      styleOverrides: {
        pageCard: {
          overflow: "hidden",
        },
        pageCardContent: {
          padding: 0,
          overflow: "hidden auto",
          "&::-webkit-scrollbar": {
            display: "none",
          },
        },
        gridContainer: {
          width: "100%",
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: theme.spacing(2.5),
          padding: theme.spacing(2, 8),
          justifyItems: "center",
        },
        gridItem: {
          display: "flex",
          flexDirection: "column",
          width: "100%",
          gap: theme.spacing(2.5),
          overflow: "auto",
        },
        emptyDataContainer: {
          minHeight: "820px",
          marginTop: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        },
        venueSelector: {
          display: "none",
        },
      },
    },
    ServiceCard: {
      styleOverrides: {
        root: {
          boxShadow: "none",
          borderRadius: "24px",
          overflow: "hidden",
          border: `0.4px solid ${theme.palette.divider}`,
          "&:first-of-type": {
            borderRadius: "32px",
          },
          "&:last-of-type": {
            borderRadius: "32px",
          },
          "&:before": {
            display: "none",
          },
          "&.Mui-expanded": {
            margin: 0,
          },
        },
        accordionSummary: {
          height: "168px",
          padding: theme.spacing(4, 3),
          gap: theme.spacing(3),
          backgroundPosition: "right center",
          backgroundRepeat: "no-repeat",
          ":after": {
            content: "''",
            position: "absolute",
            top: 0,
            right: 0,
            left: 0,
            bottom: 0,
            zIndex: 0,
            background: `linear-gradient(89deg, ${alpha(
              theme.palette.background.paper,
              0.9
            )} 49.87%, ${alpha(theme.palette.background.paper, 0)} 92.75%)`,
          },
          "& .MuiAccordionSummary-expandIconWrapper": {
            color: theme.palette.text.primary,
            "& .MuiSvgIcon-root": {
              width: "32px",
              height: "32px",
            },
          },
        },
        coverImage: {
          backgroundPosition: "right center",
          backgroundRepeat: "no-repeat",
          backgroundColor: alpha(theme.palette.background.paper, 0.8),
          backgroundBlendMode: "lighten",
          backgroundSize: "cover",
          filter: "grayscale(100%)",
          position: "absolute",
          top: 0,
          right: 0,
          bottom: 0,
          width: "60%",
        },
        summaryContainer: {
          display: "flex",
          flexDirection: "row",
          gap: theme.spacing(4),
          alignItems: "center",
          zIndex: 1,
        },
        titleText: {
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          WebkitLineClamp: 1,
          fontSize: "1.5rem",
          fontWeight: 700,
          color: theme.palette.text.primary,
          lineHeight: 1.3,
        },
        descriptionText: {
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 3,
          overflow: "hidden",
          wordBreak: "break-word",
          color: theme.palette.text.secondary,
          fontSize: "1.25rem",
          lineHeight: 1.3,
        },
        serviceIconContainer: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "64px",
          height: "64px",
          background: theme.palette.grey[200],
        },
        serviceIcon: {
          color: theme.palette.text.secondary,
          width: "40px",
          height: "40px",
        },
        infoContainer: {},
        accordionDetails: {
          padding: theme.spacing(1),
          backgroundColor: theme.palette.primary.contrastText,
        },
        locationList: {
          padding: theme.spacing(0, 3),
          overflow: "hidden auto",
          maxHeight: "280px",
          "::-webkit-scrollbar": {
            width: "4px",
          },
          "::-webkit-scrollbar-track": {
            background: theme.palette.grey[200],
          },
          "::-webkit-scrollbar-thumb": {
            background: theme.palette.primary.main,
          },
        },
        locationListItem: {
          display: "flex",
          minHeight: "48px",
          borderBottom: `solid 1px ${theme.palette.divider}`,
          padding: theme.spacing(1, 0),
          "&:last-of-type": {
            borderBottom: "none",
          },
        },
        locationNavigateButton: {
          color: theme.palette.text.primary,
          marginRight: theme.spacing(-3),
          "& .MuiSvgIcon-root": {
            width: "32px",
            height: "32px",
          },
        },
        floorTextAvatar: {
          width: "32px",
          height: "32px",
          color: theme.palette.text.secondary,
          minWidth: "32px",
          borderRadius: "50%",
          justifyContent: "center",
          alignItems: "center",
          fontSize: "1.25rem",
          display: "flex",
          marginLeft: theme.spacing(2),
          lineHeight: 1.3,
        },
        venueLogo: {
          maxHeight: "30px",
          maxWidth: "60px",
          objectFit: "contain",
        },
        venueLogoWrapper: {
          width: "92px",
          height: "32px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        divider: {
          borderColor: theme.palette.divider,
        },
        listNameText: {
          fontSize: "1.25rem",
          lineHeight: 1.3,
          color: theme.palette.text.secondary,
        },
        serviceLabel: {
          display: "none",
        },
      },
    },
    VuiFilterVenueRadioButtons: {
      styleOverrides: {
        root: {
          display: "none",
        },
      },
    },
    PlaceDetailSideBar: {
      styleOverrides: {
        root: {
          height: "100%",
        },
        headerContainer: {
          display: "flex",
          paddingTop: 0,
          height: "120px",
          width: "100%",
          gap: theme.spacing(2),
        },
        contentContainer: {
          padding: theme.spacing(4),
          gap: theme.spacing(4),
          display: "flex",
          flexDirection: "column",
          height: "100%",
        },
        descriptionContainer: {
          height: "auto",
          maxHeight: "200px",
          lineHeight: 1.4,
          overflowY: "auto",
        },
        descriptionText: {
          maxHeight: "100%",
          fontSize: "1rem",
          lineHeight: 1.3,
          marginBottom: 0,
          color: theme.palette.text.secondary,
        },
        titleText: {
          fontSize: "2rem",
          color: theme.palette.text.primary,
          lineHeight: 1.2,
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 3,
          WebkitBoxOrient: "vertical",
          fontWeight: 700,
          paddingRight: theme.spacing(10),
        },
        avatarContainer: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(1.5),
          width: "98px",
        },
        avatarRoot: {
          background: theme.palette.background.paper,
          color: theme.palette.text.secondary,
          border: `1px solid ${theme.palette.divider}`,
          margin: 0,
          height: 98,
          width: 98,
          borderRadius: "12px",
          "& .MuiSvgIcon-root": {
            width: 48,
            height: 48,
          },
        },
        venueLogoStyle: {
          display: "none",
        },
        sidebarContent: {
          background: theme.palette.background.paper,
        },
        infoListContainer: {
          display: "flex",
          gap: theme.spacing(6),
          width: "100%",
        },
        infoListItem: {
          display: "flex",
          gap: theme.spacing(1),
          "& svg": {
            display: "none",
          },
          "&.is-coming-soon": {
            "& > *,& .VuiDescriptionList-root > *": {
              color: theme.palette.error.main,
            },
          },
        },
        infoLabel: {
          alignItems: "start",
          fontWeight: 400,
          color: theme.palette.text.secondary,
        },
        openingLabel: {},
        qrCodeContainer: {
          display: "none",
        },
        qrCode: {
          width: "100px",
          height: "100px",
          padding: 0,
          "&:before": {
            display: "none",
          },
          "&:after": {
            display: "none",
          },
          "& .AppQRCode-content": {
            height: "100%",
            width: "100%",
            ":before": {
              display: "none",
            },
            ":after": {
              display: "none",
            },
          },
        },
        qrCodeCaptionContainer: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        },
        qrcodePrimaryText: {
          fontSize: "1rem",
          lineHeight: "1.2",
          fontWeight: 700,
          color: theme.palette.text.primary,
          textAlign: "center",
        },
        qrcodeSecondaryText: {
          lineHeight: "1.2",
          fontSize: "1rem",
          color: theme.palette.text.primary,
          textAlign: "center",
          fontWeight: 500,
        },
        closeButton: {
          position: "absolute",
          top: "12px",
          right: "12px",
          padding: 0,
          width: "82px",
          height: "82px",
          borderRadius: "24px",
          backgroundColor: theme.palette.background.default,
          border: `1px solid ${theme.palette.divider}`,
          "& .MuiSvgIcon-root": {
            width: "20px",
            height: "20px",
            color: theme.palette.text.primary,
          },
          "&:hover": {
            backgroundColor: theme.palette.background.default,
          },
        },
        infoContainer: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(6),
        },
        actionContainer: {
          marginTop: "auto",
          display: "flex",
          flexDirection: "row",
          gap: theme.spacing(1.5),
        },
        actionButton: {
          flex: 1,
          height: "80px",
          width: "100%",
          fontSize: "1.25rem",
          borderRadius: "24px",
        },
        galleryCarouselWrapper: {
          "&:before": {
            content: "''",
            position: "absolute",
            width: "65px",
            height: "220px",
            background:
              "linear-gradient(-90deg, rgba(256, 256, 256, 1) 0%, rgba(256, 256, 256, 0) 100%)",
            right: 0,
            zIndex: 1,
          },
          '[dir="rtl"] &:before': {
            background:
              "linear-gradient(90deg, rgba(256, 256, 256, 1) 0%, rgba(256, 256, 256, 0) 100%)",
          },
        },
        galleryCarousel: {
          position: "absolute",
          width: "480px",
          "& .splide__track": {
            margin: 0,
            padding: 0,
          },
          "& .splide__arrow": {
            margin: theme.spacing(0),
            width: "32px",
            height: "32px",
            background: theme.palette.background.default,
            opacity: 1,
            transition: "opacity 0.15s ease-in-out",
            "&:disabled": {
              opacity: 0,
              pointerEvents: "none",
            },
          },
        },
        galleryCarouselItem: {
          width: "330px !important",
          borderRadius: "4px",
        },
        galleryImage: {
          aspectRatio: "3 / 2",
          borderRadius: "4px",
        },
        newShopChip: {
          display: "none",
        },
        comingSoonChip: {
          display: "none",
        },
        galleryCarouselModal: {
          "&.PlaceDetailSideBar-galleryCarouselModal": {
            "& .AppImageCarouselModal-image": {
              width: "880px",
              height: "587px",
            },
            "& .AppImageCarouselModal-carouselItem": {
              maxWidth: "914px",
            },
          },
        },
        bottomQRCodeContainer: {
          display: "flex",
          gap: theme.spacing(2),
          height: "100px",
        },
        headerContentWrapper: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(1),
        },
      },
    },
    // NewShop and Coming will add style in next pr
    NewShopChip: {
      styleOverrides: {
        root: {},
      },
    },
    ComingSoonChip: {
      styleOverrides: {
        root: {
          padding: theme.spacing(0.5, 1.5),
          width: "fit-content",
          height: "32px",
          borderRadius: "24px",
          backgroundColor: theme.palette.warning.secondary,
          "& .MuiChip-label": {
            padding: 0,
            fontSize: "1rem",
            fontWeight: 700,
            color: theme.palette.primary.contrastText,
            textTransform: "capitalize",
          },
        },
      },
    },
    HighlightChip: {
      styleOverrides: {
        root: {
          padding: theme.spacing(0.5, 1.5),
          width: "fit-content",
          height: "32px",
          borderRadius: "24px",
          backgroundColor: "#FF0000",
          "& .MuiChip-label": {
            padding: 0,
            fontSize: "1rem",
            fontWeight: 700,
            color: theme.palette.primary.contrastText,
            textTransform: "capitalize",
          },
        },
      },
    },
    HomeActionButton: {
      styleOverrides: {
        root: {
          display: "flex",
          flexDirection: "column",
          height: "300px",
          width: "300px",
          padding: theme.spacing(2),
          background: theme.palette.primary.main,
          alignItems: "center",
          justifyContent: "center",
          transformOrigin: "center",
          transition: theme.transitions.create("transform", {
            duration: theme.transitions.duration.standard,
            easing: theme.transitions.easing.easeInOut,
          }),
          animation: "breatheScale 2s infinite ease-in-out",
          "@keyframes breatheScale": {
            "0%": { transform: "scale(1)" },
            "33.33%": { transform: "scale(0.95)" },
            "66.66%": { transform: "scale(1)" },
            "100%": { transform: "scale(1)" },
          },
          "&.Mui-selected": {
            borderRadius: "50%",
            background: `radial-gradient(50% 50% at 50% 50%, rgba(255, 255, 255, 0.20) 86.06%, rgba(246, 128, 198, 0.20) 100%), ${theme.palette.primary.main}`,
            "& .HomeActionButton-primaryText": {
              border: "none",
            },
            "& .HomeActionButton-primaryText, & .HomeActionButton-secondaryText":
              {
                color: theme.palette.primary.contrastText,
              },
            "& .MuiSvgIcon-root": {
              color: theme.palette.primary.contrastText,
            },
          },
        },
        textContainer: {
          display: "flex",
          flexDirection: "column-reverse",
          textTransform: "capitalize",
        },
        primaryText: {
          fontSize: "1.5rem",
          fontWeight: 700,
          lineHeight: "1.5",
        },
        secondaryText: {
          fontSize: "1.875rem",
          fontWeight: 700,
          lineHeight: "1.5",
        },
        icon: {
          "& .MuiSvgIcon-root": {
            width: "72px",
            height: "72px",
          },
        },
      },
    },
  },
})
